// Auto-generated from APPROVALS.xlsx + Final_Product_list docx — full regulatory composition data
export const BULK_PRODUCTS = [
  {
    "id": "p0001",
    "name": "Cisplatin Inj. IP 50 Mg/50 Ml",
    "generic": "Cisplatin",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cisplatin Inj. IP 50 Mg/50 Ml — Each ml contains.",
    "composition": [
      "CISPLATIN IP — 1 MG",
      "SODIUM CHLORIDE IP — 9 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0002",
    "name": "Cisplatin Inj. IP 10 Mg/20 Ml",
    "generic": "Cisplatin",
    "strength": "0.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cisplatin Inj. IP 10 Mg/20 Ml — Each ml contains.",
    "composition": [
      "CISPLATIN IP — 0.5 MG",
      "SODIUM CHLORIDE IP — 9 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0003",
    "name": "Paclitaxel Inj. IP 100 Mg/16.7 Ml",
    "generic": "Paclitaxel",
    "strength": "6 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Paclitaxel Inj. IP 100 Mg/16.7 Ml — Each ml contains.",
    "composition": [
      "PACLITAXEL IP — 6 MG",
      "DEHYDRATED ALCOHAL IP — 49.7% V/V",
      "POLYOXYL 35  CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0004",
    "name": "Paclitaxel Inj. IP 260 Mg/43.4 Ml",
    "generic": "Paclitaxel",
    "strength": "6 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Paclitaxel Inj. IP 260 Mg/43.4 Ml — Each ml contains.",
    "composition": [
      "PACLITAXEL IP — 6 MG",
      "DEHYDRATED ALCOHAL IP — 49.7% V/V",
      "POLYOXYL 35  CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0005",
    "name": "Docetaxel Concentrate Inj. IP",
    "generic": "1 Vial Docetaxel Inj.",
    "strength": "80 MG  (COMBI PACK)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Docetaxel Concentrate Inj. IP — Combipack contains.",
    "composition": [
      "1 VIAL DOCETAXEL INJ.",
      "DOCETAXEL TRIHYDRATE IP — 80 MG",
      "EQ. TO ANHYDROUS DOCETAXEL POLYSORBATE 80 IP — Q.S.",
      "1 VIAL OF SOLVENT FOR DOCETAXEL INJ. ALCOHAL IP — 13% V/V",
      "(95% V/V) (ABSOLUTE ALCOHOL CONTENT 15.25% V/V)",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0006",
    "name": "Docetaxel Concentrate Inj. IP",
    "generic": "1 Vial Docetaxel Inj.",
    "strength": "120 MG  (COMBI PACK)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Docetaxel Concentrate Inj. IP — Combipack contains.",
    "composition": [
      "1 VIAL DOCETAXEL INJ.",
      "DOCETAXEL TRIHYDRATE IP — 80 MG",
      "EQ. TO ANHYDROUS DOCETAXEL POLYSORBATE 80 IP — Q.S.",
      "1 VIAL OF SOLVENT FOR DOCETAXEL INJ. ALCOHAL IP — 13% V/V",
      "(95% V/V) (ABSOLUTE ALCOHOL CONTENT 15.25% V/V)",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0007",
    "name": "Zoledronic Acid Inj. IP 4 Mg",
    "generic": "Zoledronic Acid Monohydrate",
    "strength": "4 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Zoledronic Acid Inj. IP 4 Mg — Each vial contains.",
    "composition": [
      "ZOLEDRONIC ACID MONOHYDRATE",
      "EQ. TO ZOLEDRONIC ACID IP — 4 MG",
      "MANNITOL IP — 220 MG",
      "SODIUM CITRATE IP — 24 MG"
    ]
  },
  {
    "id": "p0008",
    "name": "Pemetrexed Inj. IP 100 Mg",
    "generic": "Pemetrexed Disodium Heptahydrate",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pemetrexed Inj. IP 100 Mg — Each vial contains.",
    "composition": [
      "PEMETREXED DISODIUM HEPTAHYDRATE",
      "EQ. TO PEMETREXED IP — 100 MG",
      "MANNITOL IP — 100 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0009",
    "name": "Pemetrexed Inj. IP 500 Mg",
    "generic": "Pemetrexed Disodium Heptahydrate",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pemetrexed Inj. IP 500 Mg — Each vial contains.",
    "composition": [
      "PEMETREXED DISODIUM HEPTAHYDRATE",
      "EQ. TO PEMETREXED IP — 500 MG",
      "MANNITOL IP — 500 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0010",
    "name": "Bortezumib Inj. IP 2 Mg",
    "generic": "Bortezomib",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bortezumib Inj. IP 2 Mg — Each vial contains.",
    "composition": [
      "BORTEZOMIB IP — 2 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0011",
    "name": "Fosaprepitant Dimeglumine",
    "generic": "Fosaprepitant Dimeglumine",
    "strength": "FOR INJ. 150 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Fosaprepitant Dimeglumine — Each vial contains.",
    "composition": [
      "FOSAPREPITANT DIMEGLUMINE — 245.3 mg",
      "EQ. TO FOSAPREPITANT IP — 150 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0012",
    "name": "Carboplatin Inj. IP 150 Mg/15 Ml",
    "generic": "Carboplatin",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Carboplatin Inj. IP 150 Mg/15 Ml — Each ml contains.",
    "composition": [
      "CARBOPLATIN IP — 10 MG",
      "WATER FOR INJECTION IP — Q.S."
    ]
  },
  {
    "id": "p0013",
    "name": "Carboplatin Inj. IP 450 Mg/45 Ml",
    "generic": "Carboplatin",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Carboplatin Inj. IP 450 Mg/45 Ml — Each ml contains.",
    "composition": [
      "CARBOPLATIN IP — 10 MG",
      "WATER FOR INJECTION IP — Q.S."
    ]
  },
  {
    "id": "p0014",
    "name": "Gemcitabine Inj.ip 200 Mg",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gemcitabine Inj.ip 200 Mg — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO IP — 200 MG",
      "GEMCITABINE",
      "MANNITOL IP — 200 MG",
      "SODIUM ACETATE IP — 12.5 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0015",
    "name": "Gemcitabine Inj.ip 1000 Mg",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gemcitabine Inj.ip 1000 Mg — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO IP — 1000 MG",
      "GEMCITABINE",
      "MANNITOL IP — 1000 MG",
      "SODIUM ACETATE IP — 62.5 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0016",
    "name": "Gemcitabine Injection (rtu)",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "200 MG/5.26 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gemcitabine Injection (rtu) — Each ml contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO IP",
      "EQ. TO GEMCITABINE — 38 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0017",
    "name": "Gemcitabine Injection (rtu)",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "1000 MG/26.31 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gemcitabine Injection (rtu) — Each ml contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO IP",
      "EQ. TO GEMCITABINE — 38 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0018",
    "name": "Gemcitabine Inj (rtu)",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "1400 MG / 36.8 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gemcitabine Inj (rtu) — Each ml contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO IP",
      "GEMCITABINE — 38 MG",
      "WATER FOR INJ. — Q.S."
    ]
  },
  {
    "id": "p0019",
    "name": "Epirubicin Hydrochloride Inj",
    "generic": "Epirubicin Hydrochloride",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Epirubicin Hydrochloride Inj — Each vial contains.",
    "composition": [
      "EPIRUBICIN HYDROCHLORIDE BP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0020",
    "name": "Epirubicin Hydrochloride Inj",
    "generic": "Epirubicin Hydrochloride",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Epirubicin Hydrochloride Inj — Each vial contains.",
    "composition": [
      "EPIRUBICIN HYDROCHLORIDE BP — 50 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0021",
    "name": "Bleomycin Inj. IP",
    "generic": "Bleomycin Suphate Eq. To Bleomycin",
    "strength": "15 UNITS",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bleomycin Inj. IP — Each vial contains.",
    "composition": [
      "BLEOMYCIN SUPHATE EQ. TO BLEOMYCIN IP — 15 UNITS",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0022",
    "name": "Bortezumib Inj. IP",
    "generic": "Bortezomib",
    "strength": "3.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bortezumib Inj. IP — Each vial contains.",
    "composition": [
      "BORTEZOMIB IP — 3.5 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0023",
    "name": "Docetaxel Inj. IP",
    "generic": "Docetaxel Trihydrate Eq. To",
    "strength": "(20 MG/ 1 ML)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Docetaxel Inj. IP — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE EQ. TO IP — 20 MG",
      "ANHYDROUS DOCETAXEL",
      "POLYSORBATE 80 IP — 540 MG",
      "DEHYDRATED ALCOHOL IP — 0.5 ML"
    ]
  },
  {
    "id": "p0024",
    "name": "Docetaxel Inj. IP",
    "generic": "Docetaxel Trihydrate Eq. To",
    "strength": "(80 MG/ 4 ML)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Docetaxel Inj. IP — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE EQ. TO IP — 20 MG",
      "ANHYDROUS DOCETAXEL",
      "POLYSORBATE 80 IP — 540 MG",
      "DEHYDRATED ALCOHOL IP — 0.5 ML"
    ]
  },
  {
    "id": "p0025",
    "name": "Docetaxel Inj. IP",
    "generic": "Docetaxel Trihydrate Eq. To",
    "strength": "(120 MG/ 6 ML)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Docetaxel Inj. IP — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE EQ. TO IP — 20 MG",
      "ANHYDROUS DOCETAXEL",
      "POLYSORBATE 80 IP — 540 MG",
      "DEHYDRATED ALCOHOL IP — 0.5 ML"
    ]
  },
  {
    "id": "p0026",
    "name": "Docetaxel Concentrate Inj. IP",
    "generic": "1 Vial Docetaxel Inj.",
    "strength": "20 MG (COMBIPACK)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Docetaxel Concentrate Inj. IP — Combipack contains.",
    "composition": [
      "1 VIAL DOCETAXEL INJ.",
      "DOCETAXEL TRIHYDRATE EQ. TO IP — 20 MG",
      "ANHYDROUS DOCETAXEL",
      "POLYSORBATE 80 IP — Q.S.",
      "1 VIAL OF SOLVENT FOR DOCETAXEL INJ. ALCOHAL",
      "(95% V/V) (ABSOLUTE ALCOHOL CONTENT 15.25% V/V) IP — 13% V/V",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0027",
    "name": "Carmustine Inj IP 100 Mg",
    "generic": "Carmustine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Carmustine Inj IP 100 Mg — Each vial contains.",
    "composition": [
      "CARMUSTINE IP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0028",
    "name": "Ifosfamide For Inj IP 1000 Mg",
    "generic": "Ifosfamide",
    "strength": "1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide For Inj IP 1000 Mg — Each vial contains.",
    "composition": [
      "IFOSFAMIDE IP — 1000 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0029",
    "name": "Ifosfamide For Inj. IP 1 Gm With",
    "generic": "1 Vial Ifosfamide Injection",
    "strength": "1GM",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide For Inj. IP 1 Gm With — Combipack contains.",
    "composition": [
      "1 VIAL IFOSFAMIDE INJECTION",
      "IFOSFAMIDE IP — 1GM",
      "EXCIPIENTS — Q.S.",
      "3 AMPULES MESNA INJECTION",
      "EACH ML CONTAINS:",
      "MESNA — 100 MG"
    ]
  },
  {
    "id": "p0030",
    "name": "Ifosfamide For Inj. IP 1 Gm With",
    "generic": "1 Vial Ifosfamide Injection",
    "strength": "1 GM",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide For Inj. IP 1 Gm With — Combipack contains.",
    "composition": [
      "1 VIAL IFOSFAMIDE INJECTION",
      "IFOSFAMIDE IP — 1 GM",
      "EXCIPIENTS — Q.S.",
      "1 VIAL MESNA INJECTION",
      "EACH ML CONTAINS:",
      "MESNA IP — 100 MG"
    ]
  },
  {
    "id": "p0031",
    "name": "Daunorubicin Inj. IP 20 Mg",
    "generic": "Daunorubicin Hydrochloride Eq. To",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Daunorubicin Inj. IP 20 Mg — Each vial contains.",
    "composition": [
      "DAUNORUBICIN HYDROCHLORIDE EQ. TO IP — 20 MG",
      "DAUNORUBICIN",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0032",
    "name": "Dacarbazine Inj IP 200 Mg",
    "generic": "Dacarbazine",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dacarbazine Inj IP 200 Mg — Each vial contains.",
    "composition": [
      "DACARBAZINE IP — 200 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0033",
    "name": "Decitabine Inj",
    "generic": "Decitabine",
    "strength": "30 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Decitabine Inj — Each vial contains.",
    "composition": [
      "DECITABINE — 30 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0034",
    "name": "Decitabine Inj",
    "generic": "Decitabine",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Decitabine Inj — Each 20 ml vial contains.",
    "composition": [
      "DECITABINE — 50 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0035",
    "name": "Mitoxantrone Inj USP",
    "generic": "Mitoxantrone Hydrochloride Eq. To",
    "strength": "20 MG /10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Mitoxantrone Inj USP — Each ml contains.",
    "composition": [
      "MITOXANTRONE HYDROCHLORIDE EQ. TO USP — 2 MG",
      "MITOXANTRONE",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0036",
    "name": "Mitoxantrone Inj USP",
    "generic": "Mitoxantrone Hydrochloride Eq. To",
    "strength": "25 MG /12.5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Mitoxantrone Inj USP — Each ml contains.",
    "composition": [
      "MITOXANTRONE HYDROCHLORIDE EQ. TO USP — 2 MG",
      "MITOXANTRONE",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0037",
    "name": "Ibandronic Acid Inj",
    "generic": "Ibandronic Acid Monosodium Monohydrate",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ibandronic Acid Inj — Each ml contains.",
    "composition": [
      "IBANDRONIC ACID MONOSODIUM MONOHYDRATE",
      "EQ. TO IBANDRONIC ACID — 1 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0038",
    "name": "Irinotecan Hydrochloride",
    "generic": "Irinotecan Hydrochloride Trihydrate",
    "strength": "INJ. IP 40 MG/2 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Irinotecan Hydrochloride — Each ml contains.",
    "composition": [
      "IRINOTECAN HYDROCHLORIDE TRIHYDRATE IP — 20 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0039",
    "name": "Irinotecan Hydrochloride",
    "generic": "Irinotecan Hydrochloride Trihydrate",
    "strength": "INJ. IP 100 MG/5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Irinotecan Hydrochloride — Each ml contains.",
    "composition": [
      "IRINOTECAN HYDROCHLORIDE TRIHYDRATE IP — 20 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0040",
    "name": "Topotecan Inj IP 2.5 Mg/2.5 Ml",
    "generic": "Topotecan Hydrochloride Eq. To",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Topotecan Inj IP 2.5 Mg/2.5 Ml — Each ml contains.",
    "composition": [
      "TOPOTECAN HYDROCHLORIDE EQ. TO IP",
      "TOPOTECAN — 1 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0041",
    "name": "Plerixafor Inj 24 Mg/1.2 Ml",
    "generic": "Plerixafor",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Plerixafor Inj 24 Mg/1.2 Ml — Each ml contains.",
    "composition": [
      "PLERIXAFOR — 20 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0042",
    "name": "Thiotepa Inj IP 15 Mg",
    "generic": "Thiotepa",
    "strength": "15 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Thiotepa Inj IP 15 Mg — Each vial contains.",
    "composition": [
      "THIOTEPA IP — 15 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0043",
    "name": "Vinblastine Inj. IP 10 Mg",
    "generic": "Vinblastine Sulphate",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Vinblastine Inj. IP 10 Mg — Each vial contains.",
    "composition": [
      "VINBLASTINE SULPHATE IP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0044",
    "name": "Melphalan Inj IP 50 Mg",
    "generic": "Melphalan",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Melphalan Inj IP 50 Mg — Each vial contains.",
    "composition": [
      "MELPHALAN IP — 50 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0045",
    "name": "Vinorelbine Inj IP 10 Mg / 1 Ml",
    "generic": "Vinorelbine Tartrate Eq. To Vinorelbine",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Vinorelbine Inj IP 10 Mg / 1 Ml — Each ml contains.",
    "composition": [
      "VINORELBINE TARTRATE EQ. TO VINORELBINE IP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0046",
    "name": "Vinorelbine Inj IP 50 Mg / 5 Ml",
    "generic": "Vinorelbine Tartrate Eq. To Vinorelbine",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Vinorelbine Inj IP 50 Mg / 5 Ml — Each ml contains.",
    "composition": [
      "VINORELBINE TARTRATE EQ. TO VINORELBINE IP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0047",
    "name": "Cytarabine Inj BP 100 Mg / 1 Ml",
    "generic": "Cytarabine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cytarabine Inj BP 100 Mg / 1 Ml — Each ml contains.",
    "composition": [
      "CYTARABINE IP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0048",
    "name": "Cytarabine Inj BP 500 Mg / 5 Ml",
    "generic": "Cytarabine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cytarabine Inj BP 500 Mg / 5 Ml — Each ml contains.",
    "composition": [
      "CYTARABINE IP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0049",
    "name": "Cytarabine Inj BP 1000 Mg / 10 Ml",
    "generic": "Cytarabine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cytarabine Inj BP 1000 Mg / 10 Ml — Each ml contains.",
    "composition": [
      "CYTARABINE IP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0050",
    "name": "Methotrexate Inj IP 50 Mg / 2 Ml",
    "generic": "Methotrexate",
    "strength": "25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Methotrexate Inj IP 50 Mg / 2 Ml — Each ml contains.",
    "composition": [
      "METHOTREXATE IP — 25 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0051",
    "name": "Methotrexate Inj IP 500 Mg / 20 Ml",
    "generic": "Methotrexate",
    "strength": "25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Methotrexate Inj IP 500 Mg / 20 Ml — Each ml contains.",
    "composition": [
      "METHOTREXATE IP — 25 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0052",
    "name": "Amifostine For Inj USP",
    "generic": "Amifostine (anhydrous Basis)",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Amifostine For Inj USP — Each vial contains.",
    "composition": [
      "AMIFOSTINE (ANHYDROUS BASIS) USP — 500 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0053",
    "name": "Bendamustine Hydrochlloride",
    "generic": "Bendamustine Hydrochloride",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bendamustine Hydrochlloride — Each vial contains.",
    "composition": [
      "BENDAMUSTINE HYDROCHLORIDE IP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0054",
    "name": "Cabazitaxel Inj 60 Mg/1.5 Ml",
    "generic": "Cabazitaxel",
    "strength": "60 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cabazitaxel Inj 60 Mg/1.5 Ml — Each 1.5 ml contains.",
    "composition": [
      "CABAZITAXEL IP — 60 MG",
      "ETHANOL (13% W/W) IP — 5.7 ML",
      "WATER FOR INJECTION IP — Q.S."
    ]
  },
  {
    "id": "p0055",
    "name": "Carfilzomib Sterlized Lyophilized",
    "generic": "Carfilzomib",
    "strength": "60 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Carfilzomib Sterlized Lyophilized — Each vial contains.",
    "composition": [
      "CARFILZOMIB IP — 60 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0056",
    "name": "Oxaliplatin Inj. USP 50 Mg/25 Ml",
    "generic": "Oxaliplatin",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Oxaliplatin Inj. USP 50 Mg/25 Ml — Each ml contains.",
    "composition": [
      "OXALIPLATIN USP — 2 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0057",
    "name": "Oxaliplatin Inj. USP 100 Mg/50 Ml",
    "generic": "Oxaliplatin",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Oxaliplatin Inj. USP 100 Mg/50 Ml — Each ml contains.",
    "composition": [
      "OXALIPLATIN USP — 2 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0058",
    "name": "Oxaliplatin Inj. USP 50 Mg/10 Ml",
    "generic": "Oxaliplatin",
    "strength": "5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Oxaliplatin Inj. USP 50 Mg/10 Ml — Each ml contains.",
    "composition": [
      "OXALIPLATIN IP — 5 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0059",
    "name": "Oxaliplatin Inj. USP 100 Mg/20 Ml",
    "generic": "Oxaliplatin",
    "strength": "5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Oxaliplatin Inj. USP 100 Mg/20 Ml — Each ml contains.",
    "composition": [
      "OXALIPLATIN IP — 5 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0060",
    "name": "Fludarabine Phosphate Inj IP",
    "generic": "Fludarabine Phosphate",
    "strength": "50 MG/2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Fludarabine Phosphate Inj IP — Each ml contains.",
    "composition": [
      "FLUDARABINE PHOSPHATE IP — 25 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0061",
    "name": "Vancomycin Hydrochloride",
    "generic": "Vancomycin Hydrochloride",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Vancomycin Hydrochloride — Each vial contains.",
    "composition": [
      "VANCOMYCIN HYDROCHLORIDE IP",
      "EQ. TO VANCOMYCIN — 500 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0062",
    "name": "Vancomycin Hydrochloride",
    "generic": "Vancomycin Hydrochloride",
    "strength": "1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Vancomycin Hydrochloride — Each vial contains.",
    "composition": [
      "VANCOMYCIN HYDROCHLORIDE IP",
      "EQ. TO VANCOMYCIN — 1000 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0063",
    "name": "Paclitaxel Inj. IP 30 Mg/5 Ml",
    "generic": "Paclitaxel",
    "strength": "6 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Paclitaxel Inj. IP 30 Mg/5 Ml — Each ml contains.",
    "composition": [
      "PACLITAXEL IP — 6 MG",
      "DEHYDRATED ALCOHOL IP — 49.7% V/V",
      "POLYOXYL 25 CASTOR OIL UNSF — 527 MG"
    ]
  },
  {
    "id": "p0064",
    "name": "Paclitaxel Inj. IP 300 Mg/50 Ml",
    "generic": "Paclitaxel",
    "strength": "6 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Paclitaxel Inj. IP 300 Mg/50 Ml — Each ml contains.",
    "composition": [
      "PACLITAXEL IP — 6 MG",
      "DEHYDRATED ALCOHOL IP — 49.7% V/V",
      "POLYOXYL 25 CASTOR OIL UNSF — 527 MG"
    ]
  },
  {
    "id": "p0065",
    "name": "Dactinomycin For Inj. USP 0.5 Mg",
    "generic": "Dactinomycin",
    "strength": "0.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dactinomycin For Inj. USP 0.5 Mg — Each vial contains.",
    "composition": [
      "DACTINOMYCIN USP — 0.5 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0066",
    "name": "Azacitidine For Inj. 100 Mg",
    "generic": "Azacitidine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Azacitidine For Inj. 100 Mg — Each vial contains.",
    "composition": [
      "AZACITIDINE — 100 MG",
      "EXCIPIENTS IP — Q.S."
    ]
  },
  {
    "id": "p0067",
    "name": "Etoposide Inj IP 100 Mg/5 Ml",
    "generic": "Etoposide",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Etoposide Inj IP 100 Mg/5 Ml — Each ml contains.",
    "composition": [
      "ETOPOSIDE IP — 20 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0068",
    "name": "Fluderabine Phosphate For Inj.",
    "generic": "Fludarabine Phosphate",
    "strength": "USP 50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Fluderabine Phosphate For Inj. — Each vial contains.",
    "composition": [
      "FLUDARABINE PHOSPHATE USP — 50 MG",
      "MANNITOL IP — 50 MG"
    ]
  },
  {
    "id": "p0069",
    "name": "Cladribine Inj 10mg/10 Ml",
    "generic": "Cladribine",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cladribine Inj 10mg/10 Ml — Each ml contains.",
    "composition": [
      "CLADRIBINE — 1 MG",
      "SODIUM CHLORIDE IP — 9 MG",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0070",
    "name": "Voriconazole Inj IP",
    "generic": "Voriconazole",
    "strength": "200 mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Voriconazole Inj IP — Each vial contains.",
    "composition": [
      "VORICONAZOLE IP — 200 mg",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0071",
    "name": "Vinblastine Inj IP",
    "generic": "Vinblastine Sulphate",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Vinblastine Inj IP — Each vial contains.",
    "composition": [
      "VINBLASTINE SULPHATE IP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0072",
    "name": "Vincristine Sulphate Inj USP 1 Mg",
    "generic": "Vincristine Sulphate",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Vincristine Sulphate Inj USP 1 Mg — Each ml contains.",
    "composition": [
      "VINCRISTINE SULPHATE USP — 1 ML",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0073",
    "name": "Doxorubicin Injection IP",
    "generic": "Doxorubicin Injection",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Doxorubicin Injection IP — Each vial contains.",
    "composition": [
      "DOXORUBICIN INJECTION IP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0074",
    "name": "Doxorubicin Injection IP",
    "generic": "Doxorubicin Injection",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Doxorubicin Injection IP — Each vial contains.",
    "composition": [
      "DOXORUBICIN INJECTION IP — 50 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0075",
    "name": "Doxorubicin Hydrochloride",
    "generic": "Doxorubicin Hydrochloride",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Doxorubicin Hydrochloride — Each ml contains.",
    "composition": [
      "DOXORUBICIN HYDROCHLORIDE IP — 2 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0076",
    "name": "Paclitaxel (protein Bound Particles)",
    "generic": "Paclitaxel",
    "strength": "FOR INJECTABLE SUSPENSION 100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Paclitaxel (protein Bound Particles) — Each vial contains.",
    "composition": [
      "PACLITAXEL IP — 100 MG",
      "HUMAN ALBUMIN IP — 900 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0077",
    "name": "Mitomycin Inj IP",
    "generic": "Mitomycin",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Mitomycin Inj IP — Each vial contains.",
    "composition": [
      "MITOMYCIN IP — 2 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0078",
    "name": "Gemcitabine Inj IP",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "1400 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gemcitabine Inj IP — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO IP",
      "GEMCITABINE — 1400 MG",
      "WATER FOR INNJ IP — Q.S."
    ]
  },
  {
    "id": "p0079",
    "name": "Calcium Folinate Inj. IP",
    "generic": "Calcium Folinate",
    "strength": "50 MG/5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Calcium Folinate Inj. IP — Each ml contains.",
    "composition": [
      "CALCIUM FOLINATE IP",
      "EQ. TO FOLINIC ACID — 10 MG",
      "METHYLPARABEN IP — 0.08% W/V",
      "PROPYLPARABEN IP — 0.02%W/V",
      "WATER FOR INJ. IP — Q.S."
    ]
  },
  {
    "id": "p0080",
    "name": "Thiotepa Inj. BP 100 Mg",
    "generic": "Thiotepa",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Thiotepa Inj. BP 100 Mg — Each vial contains.",
    "composition": [
      "THIOTEPA BP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0081",
    "name": "Ifosfamide For Inj. IP 2 G With",
    "generic": "One Vial Ifosfamide Inj.",
    "strength": "2 GM",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide For Inj. IP 2 G With — Each combipack contains.",
    "composition": [
      "ONE VIAL IFOSFAMIDE INJ.",
      "IFOSFAMIDE IP — 2 GM",
      "ONE VIAL MESNA INJ.",
      "EACH ML CONTAINS:",
      "MESNA IP — 100 MG"
    ]
  },
  {
    "id": "p0082",
    "name": "Busulphan Injection",
    "generic": "Busulphan",
    "strength": "60 MG/10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Busulphan Injection — Each vial contains.",
    "composition": [
      "BUSULPHAN IP — 60 MG",
      "N.N-DIMETHYLACITAMIDE IP — 3.3 ML",
      "POLYETHYLENE GLYCOL 400 IP — 6.7 ML"
    ]
  },
  {
    "id": "p0083",
    "name": "Palonosetron Hydrochloride",
    "generic": "Palonosetron Hydrochloride",
    "strength": "INJECTION 0.25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Palonosetron Hydrochloride — Each 5 ml vial contains.",
    "composition": [
      "PALONOSETRON HYDROCHLORIDE USP",
      "EQ. TO PALONOSETRON — 0.25 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0084",
    "name": "Fluorouracil IP 500 Mg / 10 Ml",
    "generic": "Fluorouracil",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Fluorouracil IP 500 Mg / 10 Ml — Each ml contains.",
    "composition": [
      "FLUOROURACIL IP — 50 MG",
      "WATER FOR INJECTION IP — q.s."
    ]
  },
  {
    "id": "p0085",
    "name": "Granisetron Injection IP",
    "generic": "Granisetron Hydrochloride",
    "strength": "1MG/ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Granisetron Injection IP — Each ml contains.",
    "composition": [
      "GRANISETRON HYDROCHLORIDE IP",
      "EQ. TO GRANISETRON — 1 MG",
      "WATER FOR INJECTION — q.s."
    ]
  },
  {
    "id": "p0086",
    "name": "Bortezomib Injection IP 1 Mg",
    "generic": "Bortezomib",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bortezomib Injection IP 1 Mg — Each vial contains.",
    "composition": [
      "BORTEZOMIB IP — 1 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0087",
    "name": "Leucovorin Calcium Injection USP",
    "generic": "Leucovorin Calcium Eq. To Leucovorin",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Leucovorin Calcium Injection USP — Each ml contains.",
    "composition": [
      "LEUCOVORIN CALCIUM EQ. TO LEUCOVORIN USP — 10 MG",
      "METHYLPARABEN USP — 0.08% W/V",
      "PROPYLPARABEN USP — 0.02% W/V",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0088",
    "name": "Epirubicin Injection IP 50 Mg/25 Ml",
    "generic": "Epirubicin Hydrochloride",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Epirubicin Injection IP 50 Mg/25 Ml — Each ml contains.",
    "composition": [
      "EPIRUBICIN HYDROCHLORIDE IP — 2 MG",
      "WATER FOR INJECTION IP — q.s."
    ]
  },
  {
    "id": "p0089",
    "name": "Methotrexate Inj IP 1000 Mg / 40 Ml",
    "generic": "Methotrexate",
    "strength": "25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Methotrexate Inj IP 1000 Mg / 40 Ml — Each ml contains.",
    "composition": [
      "METHOTREXATE IP — 25 MG",
      "WATER FOR INJ IP — Q.S."
    ]
  },
  {
    "id": "p0090",
    "name": "Pegaspargase Injection",
    "generic": "Pegaspargase Pegylated L-asparaginase",
    "strength": "3750 IU/5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pegaspargase Injection — Each 5 ml vial contains.",
    "composition": [
      "PEGASPARGASE PEGYLATED L-ASPARAGINASE — 3750 IU"
    ]
  },
  {
    "id": "p0091",
    "name": "Carfilzomib For Injection 30 Mg",
    "generic": "Carfilzomib",
    "strength": "30 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Carfilzomib For Injection 30 Mg — Each vial contains.",
    "composition": [
      "CARFILZOMIB — 30 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0092",
    "name": "Ifosfamide For Injection 2 G",
    "generic": "Ifosfamide",
    "strength": "2g",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide For Injection 2 G — Each vial contains.",
    "composition": [
      "IFOSFAMIDE IP — 2g",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0093",
    "name": "Calcium Folinate Inj. IP",
    "generic": "Calcium Folinate",
    "strength": "100 MG/10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Calcium Folinate Inj. IP — Each ml contains.",
    "composition": [
      "CALCIUM FOLINATE IP",
      "EQ. TO FOLINIC ACID — 10 MG",
      "METHYLPARABEN IP — 0.08%W/V",
      "PROPYLPARABEN IP — 0.02% W/V",
      "WATER FOR INJECTION IP — q.s."
    ]
  },
  {
    "id": "p0094",
    "name": "Dacarbazine Inj IP 500 Mg",
    "generic": "Dacarbazine",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dacarbazine Inj IP 500 Mg — Each vial contains.",
    "composition": [
      "DACARBAZINE IP — 500 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0095",
    "name": "Bortezomib Injection IP",
    "generic": "Bortezomib",
    "strength": "2.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bortezomib Injection IP — Each vial contains.",
    "composition": [
      "BORTEZOMIB IP — 2.5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0096",
    "name": "Leuprolide Acetate For Inj. (depot)",
    "generic": "Leuprolide Acetate",
    "strength": "3.75 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Leuprolide Acetate For Inj. (depot) — Each vial contains:(as lyophilized powder).",
    "composition": [
      "LEUPROLIDE ACETATE USP — 3.75 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0097",
    "name": "Leuprolide Acetate For Inj. (depot)",
    "generic": "Leuprolide Acetate",
    "strength": "11.25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Leuprolide Acetate For Inj. (depot) — Each vial contains:(as lyophilized powder).",
    "composition": [
      "LEUPROLIDE ACETATE USP — 11.25 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0098",
    "name": "Leuprolide Acetate For Inj. (depot)",
    "generic": "Leuprolide Acetate",
    "strength": "22.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Leuprolide Acetate For Inj. (depot) — Each vial contains:(as lyophilized powder).",
    "composition": [
      "LEUPROLIDE ACETATE USP — 22.5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0099",
    "name": "Temozolamide Inj. IP 100 Mg",
    "generic": "Temozolamide",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Temozolamide Inj. IP 100 Mg — Each vial contains: (as lyophilized powder).",
    "composition": [
      "TEMOZOLAMIDE IP — 100 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0100",
    "name": "Methotrexate Injection IP",
    "generic": "Methotrexate",
    "strength": "25 MG / 1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Methotrexate Injection IP — Each ml contains.",
    "composition": [
      "METHOTREXATE IP — 25 MG",
      "WATER FOR INJECTION IP — q.s."
    ]
  },
  {
    "id": "p0101",
    "name": "Imatinib Tablets IP 400 Mg",
    "generic": "Imatinib Mesylate Eq. To Imatinib",
    "strength": "400 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Imatinib Tablets IP 400 Mg — Each film coated tablet contains.",
    "composition": [
      "IMATINIB MESYLATE EQ. TO IMATINIB IP — 400 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0102",
    "name": "Imatinib Tablets IP 100 Mg",
    "generic": "Imatinib Mesylate Eq. To Imatinib",
    "strength": "100 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Imatinib Tablets IP 100 Mg — Each film coated tablet contains.",
    "composition": [
      "IMATINIB MESYLATE EQ. TO IMATINIB IP — 100 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0103",
    "name": "Capecitabiine Tablets IP",
    "generic": "Capecitabine",
    "strength": "500 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Capecitabiine Tablets IP — Each film coated tablet contains.",
    "composition": [
      "CAPECITABINE IP — 500 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0104",
    "name": "Capecitabiine Tablets IP",
    "generic": "Capecitabine",
    "strength": "150 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Capecitabiine Tablets IP — Each film coated tablet contains.",
    "composition": [
      "CAPECITABINE IP — 150 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0105",
    "name": "Gefitinib Tablets IP 250 Mg",
    "generic": "Gefitinib",
    "strength": "250 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Gefitinib Tablets IP 250 Mg — Each film coated tablet contains.",
    "composition": [
      "GEFITINIB IP — 250 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0106",
    "name": "Erlotinib Tablets IP 150 Mg",
    "generic": "Erlotinib Hydrochloride Eq . To.",
    "strength": "150 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Erlotinib Tablets IP 150 Mg — Each film coated tablet contains.",
    "composition": [
      "ERLOTINIB HYDROCHLORIDE EQ . TO.",
      "ERLOTINIB IP — 150 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0107",
    "name": "Erlotinib Tablet IP 100 Mg",
    "generic": "Erlotinib Hydrochloride Eq . To.",
    "strength": "100 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Erlotinib Tablet IP 100 Mg — Each film coated tablet contains.",
    "composition": [
      "ERLOTINIB HYDROCHLORIDE EQ . TO.",
      "ERLOTINIB IP — 100 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0108",
    "name": "Flutamide Tablet IP 250 Mg",
    "generic": "Flutamide",
    "strength": "250 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Flutamide Tablet IP 250 Mg — Each uncoated tablet contains.",
    "composition": [
      "FLUTAMIDE IP — 250 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0109",
    "name": "Anastrazole Tablets IP 1 Mg",
    "generic": "Anastrazole",
    "strength": "1 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Anastrazole Tablets IP 1 Mg — Each film coated tablet contains.",
    "composition": [
      "ANASTRAZOLE IP — 1 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0110",
    "name": "Bicalutamide Tablets IP 50 Mg",
    "generic": "Bicalutamide",
    "strength": "50 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bicalutamide Tablets IP 50 Mg — Each film coated tablet contains.",
    "composition": [
      "BICALUTAMIDE IP — 50 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0111",
    "name": "Bicalutamide Tablets IP 150 Mg",
    "generic": "Bicalutamide",
    "strength": "150 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Bicalutamide Tablets IP 150 Mg — Each film coated tablet contains.",
    "composition": [
      "BICALUTAMIDE IP — 150 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0112",
    "name": "Dasatinib Tablets 20 Mg",
    "generic": "Dasatinib",
    "strength": "20 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dasatinib Tablets 20 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 20 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0113",
    "name": "Dasatinib Tablets 50 Mg",
    "generic": "Dasatinib",
    "strength": "50 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dasatinib Tablets 50 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 50 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0114",
    "name": "Dasatinib Tablets 70 Mg",
    "generic": "Dasatinib",
    "strength": "70 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dasatinib Tablets 70 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 70 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0115",
    "name": "Dasatinib Tablets 100 Mg",
    "generic": "Dasatinib",
    "strength": "100 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Dasatinib Tablets 100 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 100 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0116",
    "name": "Lapatinib Tablets IP 250 Mg",
    "generic": "Lapatinib Ditosylate",
    "strength": "250 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lapatinib Tablets IP 250 Mg — Each film coated tablet contains.",
    "composition": [
      "LAPATINIB DITOSYLATE IP",
      "EQ. TO LAPATINIB — 250 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0117",
    "name": "Letrazole Tablet IP 2.5 Mg",
    "generic": "Letrazole",
    "strength": "2.5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Letrazole Tablet IP 2.5 Mg — Each film coated tablet contains.",
    "composition": [
      "LETRAZOLE IP — 2.5 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0118",
    "name": "Pazopanib Hydrochloride",
    "generic": "Pazopanib Hydrochloride",
    "strength": "TABLET 200 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pazopanib Hydrochloride — Each film coated tablet contains.",
    "composition": [
      "PAZOPANIB HYDROCHLORIDE",
      "EQ. TO PAZOPANIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0119",
    "name": "Pazopanib Hydrochloride",
    "generic": "Pazopanib Hydrochloride",
    "strength": "TABLET 400 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pazopanib Hydrochloride — Each film coated tablet contains.",
    "composition": [
      "PAZOPANIB HYDROCHLORIDE",
      "EQ. TO PAZOPANIB — 400 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0120",
    "name": "Cyclophosphamide Tablet",
    "generic": "Cyclophosphamide",
    "strength": "IP 50 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cyclophosphamide Tablet — Each film coated tablet contains.",
    "composition": [
      "CYCLOPHOSPHAMIDE IP",
      "EQ. TO ANHYDROUS CYCLOPHOSPHAMIDE — 50 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0121",
    "name": "Mercaptopurine Tablet",
    "generic": "Mercaptopurine",
    "strength": "IP 50 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Mercaptopurine Tablet — Each uncoated tablet contains.",
    "composition": [
      "MERCAPTOPURINE IP — 50 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0122",
    "name": "Afatinib Tablet 20 Mg",
    "generic": "Afatinib Dimaleate",
    "strength": "20 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Afatinib Tablet 20 Mg — Each film coated tablet contains.",
    "composition": [
      "AFATINIB DIMALEATE",
      "EQ. TO AFATINIB — 20 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0123",
    "name": "Afatinib Tablet 30 Mg",
    "generic": "Afatinib Dimaleate",
    "strength": "30 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Afatinib Tablet 30 Mg — Each film coated tablet contains.",
    "composition": [
      "AFATINIB DIMALEATE",
      "EQ. TO AFATINIB — 30 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0124",
    "name": "Afatinib Tablet 40 Mg",
    "generic": "Afatinib Dimaleate",
    "strength": "40 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Afatinib Tablet 40 Mg — Each film coated tablet contains.",
    "composition": [
      "AFATINIB DIMALEATE",
      "EQ. TO AFATINIB — 40 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0125",
    "name": "Exemestane Tablet IP 25 Mg",
    "generic": "Exemestane",
    "strength": "25 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Exemestane Tablet IP 25 Mg — Each film coated tablet contains.",
    "composition": [
      "EXEMESTANE IP — 25 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0126",
    "name": "Tamoxifen Tablet IP 10 Mg",
    "generic": "Tamoxifen Citrate",
    "strength": "10 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Tamoxifen Tablet IP 10 Mg — Each uncoated tablet contains.",
    "composition": [
      "TAMOXIFEN CITRATE IP",
      "EQ. TO TAMOXIFEN — 10 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0127",
    "name": "Tamoxifen Tablet IP 20 Mg",
    "generic": "Tamoxifen Citrate",
    "strength": "20 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Tamoxifen Tablet IP 20 Mg — Each uncoated tablet contains.",
    "composition": [
      "TAMOXIFEN CITRATE IP",
      "EQ. TO TAMOXIFEN — 20 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0128",
    "name": "Methotrexate Tablet IP",
    "generic": "Methotrexate",
    "strength": "2.5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Methotrexate Tablet IP — Each uncoated tablet contains.",
    "composition": [
      "METHOTREXATE IP — 2.5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0129",
    "name": "Methotrexate Tablet IP",
    "generic": "Methotrexate",
    "strength": "5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Methotrexate Tablet IP — Each uncoated tablet contains.",
    "composition": [
      "METHOTREXATE IP — 5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0130",
    "name": "Megestrol Acetate Tablet",
    "generic": "Megestrol Acetate",
    "strength": "IP 20 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Megestrol Acetate Tablet — Each uncoated tablet contains.",
    "composition": [
      "MEGESTROL ACETATE IP — 20 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0131",
    "name": "Megestrol Acetate Tablet",
    "generic": "Megestrol Acetate",
    "strength": "IP 160 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Megestrol Acetate Tablet — Each uncoated tablet contains.",
    "composition": [
      "MEGESTROL ACETATE IP — 160 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0132",
    "name": "Abiraterone Acetate Tablet",
    "generic": "Abiraterone Acetate",
    "strength": "IP 250 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Abiraterone Acetate Tablet — Each uncoated tablet contains.",
    "composition": [
      "ABIRATERONE ACETATE IP — 250 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0133",
    "name": "Sorafenib Tablet IP 200 Mg",
    "generic": "Sorafenib Tosylate",
    "strength": "200 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Sorafenib Tablet IP 200 Mg — Each film coated tablet contains.",
    "composition": [
      "SORAFENIB TOSYLATE IP",
      "EQ. TO SORAFENIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0134",
    "name": "Everolimus Tablet 5 Mg",
    "generic": "Everolimus",
    "strength": "5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Everolimus Tablet 5 Mg — Each uncoated tablet contains.",
    "composition": [
      "EVEROLIMUS BP — 5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0135",
    "name": "Everolimus Tablet 10 Mg",
    "generic": "Everolimus",
    "strength": "10 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Everolimus Tablet 10 Mg — Each uncoated tablet contains.",
    "composition": [
      "EVEROLIMUS BP — 10 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0136",
    "name": "Chlorambucil IP 2 Mg",
    "generic": "Chlorambucil",
    "strength": "2 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Chlorambucil IP 2 Mg — Each film coated tablet contains.",
    "composition": [
      "CHLORAMBUCIL IP — 2 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0137",
    "name": "Chlorambucil IP 5 Mg",
    "generic": "Chlorambucil",
    "strength": "5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Chlorambucil IP 5 Mg — Each film coated tablet contains.",
    "composition": [
      "CHLORAMBUCIL IP — 5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0138",
    "name": "Melphalan IP 2 Mg",
    "generic": "Melphalan",
    "strength": "2 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Melphalan IP 2 Mg — Each film coated tablet contains.",
    "composition": [
      "MELPHALAN IP — 2 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0139",
    "name": "Abiraterone Acetate Tablet",
    "generic": "Abiraterone Acetate",
    "strength": "500 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Abiraterone Acetate Tablet — Each uncoated tablet contains.",
    "composition": [
      "ABIRATERONE ACETATE IP — 500 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0140",
    "name": "Capecitabine Dispersible",
    "generic": "Capecitabine",
    "strength": "TABLET 1000 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Capecitabine Dispersible — Each uncoated tablet contains.",
    "composition": [
      "CAPECITABINE IP — 1000 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0141",
    "name": "Capecitabine Dispersible",
    "generic": "Capecitabine",
    "strength": "TABLET 500 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Capecitabine Dispersible — Each uncoated tablet contains.",
    "composition": [
      "CAPECITABINE IP — 500 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0142",
    "name": "Axitinib Tablet 1 Mg",
    "generic": "Axitinib",
    "strength": "1 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Axitinib Tablet 1 Mg — Each film coated tablet contains.",
    "composition": [
      "AXITINIB — 1 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0143",
    "name": "Axitinib Tablet 5 Mg",
    "generic": "Axitinib",
    "strength": "5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Axitinib Tablet 5 Mg — Each film coated tablet contains.",
    "composition": [
      "AXITINIB — 5 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0144",
    "name": "Eltrombopag Olamine",
    "generic": "Eltrombopag Olamine",
    "strength": "TABLET 25 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Eltrombopag Olamine — Each film coated tablet contains.",
    "composition": [
      "ELTROMBOPAG OLAMINE",
      "EQ. TO ELTROMBOPAG (AS FREE ACID) — 25 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0145",
    "name": "Eltrombopag Olamine Tablet 50 Mg",
    "generic": "Eltrombopag Olamine",
    "strength": "50 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Eltrombopag Olamine Tablet 50 Mg — Each film coated tablet contains.",
    "composition": [
      "ELTROMBOPAG OLAMINE",
      "EQ. TO ELTROMBOPAG (AS FREE ACID) — 50 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0146",
    "name": "Eltrombopag Olamine Tablet 75 Mg",
    "generic": "Eltrombopag Olamine",
    "strength": "75 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Eltrombopag Olamine Tablet 75 Mg — Each film coated tablet contains.",
    "composition": [
      "ELTROMBOPAG OLAMINE",
      "EQ. TO ELTROMBOPAG (AS FREE ACID) — 75 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0147",
    "name": "Letrazole Tablet IP 5 Mg",
    "generic": "Letrazole",
    "strength": "5 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Letrazole Tablet IP 5 Mg — Each film coated tablet contains.",
    "composition": [
      "LETRAZOLE IP — 5 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0148",
    "name": "Megestrol Acetate",
    "generic": "Megestrol Acetate",
    "strength": "80 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Megestrol Acetate — Each uncoated tablet contains.",
    "composition": [
      "MEGESTROL ACETATE IP — 80 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0149",
    "name": "Olaparib Tablet 100 Mg",
    "generic": "Olaparib",
    "strength": "100 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Olaparib Tablet 100 Mg — Each film coated tablet contains.",
    "composition": [
      "OLAPARIB — 100 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0150",
    "name": "Olaparib Tablet 150 Mg",
    "generic": "Olaparib",
    "strength": "150 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Olaparib Tablet 150 Mg — Each film coated tablet contains.",
    "composition": [
      "OLAPARIB — 150 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0151",
    "name": "Regorafenib Tablet",
    "generic": "Regorafenib Monohydrate",
    "strength": "BP 40 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Regorafenib Tablet — Each film coated tablet contains.",
    "composition": [
      "REGORAFENIB MONOHYDRATE BP",
      "EQ. TO REGORAFENIB — 40 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0152",
    "name": "Regorafenib Tablet",
    "generic": "Regorafenib Monohydrate",
    "strength": "40 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Regorafenib Tablet — Each film coated tablet contains.",
    "composition": [
      "REGORAFENIB MONOHYDRATE USP",
      "EQ. TO REGORAFENIB — 40 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0153",
    "name": "Hydroxyurea Tablet",
    "generic": "Hydroxyurea",
    "strength": "1000 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Hydroxyurea Tablet — Each uncoated tablet contains.",
    "composition": [
      "HYDROXYUREA IP — 1000 mg",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0154",
    "name": "Megestrol Acetate Tablet IP",
    "generic": "Megestrol Acetate",
    "strength": "40 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Megestrol Acetate Tablet IP — Each uncoated tablet contains.",
    "composition": [
      "MEGESTROL ACETATE IP — 40 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0155",
    "name": "Ribociclib Tablet 200 Mg",
    "generic": "Ribociclib Succinate",
    "strength": "254.40 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ribociclib Tablet 200 Mg — Each film coated tablet contains.",
    "composition": [
      "RIBOCICLIB SUCCINATE — 254.40 MG",
      "EQ. TO RIBOCICLIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0156",
    "name": "Osimertinib Tablet 40 Mg",
    "generic": "Osimertinib Mesylate",
    "strength": "47.7 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Osimertinib Tablet 40 Mg — Each film coated tablet contains.",
    "composition": [
      "OSIMERTINIB MESYLATE — 47.7 MG",
      "EQ. TO OSIMERTINIB — 40.0 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0157",
    "name": "Osimertinib Tablet 80 Mg",
    "generic": "Osimertinib Mesylate",
    "strength": "95.4 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Osimertinib Tablet 80 Mg — Each film coated tablet contains.",
    "composition": [
      "OSIMERTINIB MESYLATE — 95.4 MG",
      "EQ. TO OSIMERTINIB — 80.0 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0158",
    "name": "Erlotinib Tablet 150 Mg",
    "generic": "Erlotinib Hydrochloride",
    "strength": "150 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Erlotinib Tablet 150 Mg — Each film coated tablet contains.",
    "composition": [
      "ERLOTINIB HYDROCHLORIDE",
      "EQ. TO ERLOTINIB — 150 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0159",
    "name": "Venetoclax Tablet 10 Mg",
    "generic": "Venetoclax",
    "strength": "10 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Venetoclax Tablet 10 Mg — Each film coated tablet contains.",
    "composition": [
      "VENETOCLAX — 10 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0160",
    "name": "Venetoclax Tablet 50 Mg",
    "generic": "Venetoclax",
    "strength": "50 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Venetoclax Tablet 50 Mg — Each film coated tablet contains.",
    "composition": [
      "VENETOCLAX — 50 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0161",
    "name": "Venetoclax Tablet 100 Mg",
    "generic": "Venetoclax",
    "strength": "100 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Venetoclax Tablet 100 Mg — Each film coated tablet contains.",
    "composition": [
      "VENETOCLAX — 100 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0162",
    "name": "Temozolamide Capsule IP 20 Mg",
    "generic": "Temozolamide",
    "strength": "20 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Temozolamide Capsule IP 20 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE IP — 20 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0163",
    "name": "Temozolamide Capsule IP 100 Mg",
    "generic": "Temozolamide",
    "strength": "100 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Temozolamide Capsule IP 100 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE IP — 100 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0164",
    "name": "Temozolamide Capsule IP 250 Mg",
    "generic": "Temozolamide",
    "strength": "250 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Temozolamide Capsule IP 250 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE IP — 250 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0165",
    "name": "Thalidomide Capsule IP 50 Mg",
    "generic": "Thalidomide",
    "strength": "50 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Thalidomide Capsule IP 50 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "THALIDOMIDE USP — 50 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0166",
    "name": "Thalidomide Capsule IP 100 Mg",
    "generic": "Thalidomide",
    "strength": "100 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Thalidomide Capsule IP 100 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "THALIDOMIDE USP — 100 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0167",
    "name": "Lenalidomide Capsule IP 10 Mg",
    "generic": "Lenalidomide",
    "strength": "10 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lenalidomide Capsule IP 10 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENALIDOMIDE — 10 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0168",
    "name": "Lenalidomide Capsule IP 25 Mg",
    "generic": "Lenalidomide",
    "strength": "25 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lenalidomide Capsule IP 25 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENALIDOMIDE — 25 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0169",
    "name": "Hydroxyurea Capsule USP 500 Mg",
    "generic": "Hydroxyurea",
    "strength": "500 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Hydroxyurea Capsule USP 500 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "HYDROXYUREA USP / IP — 500 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0170",
    "name": "Etoposide Capsule IP 50 Mg",
    "generic": "Etoposide",
    "strength": "50 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Etoposide Capsule IP 50 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ETOPOSIDE IP — 50 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0171",
    "name": "Aprepitant Capsule IP",
    "generic": "1 Capsule Aprepitant 125 Mg",
    "strength": "80 MG / 125 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Aprepitant Capsule IP — Combipack contains.",
    "composition": [
      "1 CAPSULE APREPITANT 125 MG",
      "APREPITANT IP — 125 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL",
      "2 CAPSULE APREPITANT 80 MG",
      "APREPITANT IP — 80 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0172",
    "name": "Imatinib Capsule IP 100 Mg",
    "generic": "Imatinib Mesylate Eq. To",
    "strength": "100 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Imatinib Capsule IP 100 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "IMATINIB MESYLATE EQ. TO IP",
      "IMATINIB — 100 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0173",
    "name": "Imatinib Capsule IP 400 Mg",
    "generic": "Imatinib Mesylate Eq. To",
    "strength": "400 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Imatinib Capsule IP 400 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "IMATINIB MESYLATE EQ. TO IP",
      "IMATINIB — 400 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0174",
    "name": "Sunitinib Maleate Capsule",
    "generic": "Sunitinib Maleate Eq. To",
    "strength": "12.5 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Sunitinib Maleate Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "SUNITINIB MALEATE EQ. TO",
      "SUNITINIB — 12.5 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0175",
    "name": "Sunitinib Maleate Capsule",
    "generic": "Sunitinib Maleate Eq. To",
    "strength": "25 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Sunitinib Maleate Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "SUNITINIB MALEATE EQ. TO",
      "SUNITINIB — 25 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0176",
    "name": "Sunitinib Maleate Capsule",
    "generic": "Sunitinib Maleate Eq. To",
    "strength": "50 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Sunitinib Maleate Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "SUNITINIB MALEATE EQ. TO",
      "SUNITINIB — 50 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0177",
    "name": "Lenvatinib Capsule 4 Mg",
    "generic": "Lenvatinib Mesylate Eq. To",
    "strength": "4.9 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lenvatinib Capsule 4 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENVATINIB MESYLATE EQ. TO — 4.9 MG",
      "LENVATINIB — 4 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0178",
    "name": "Lenvatinib Capsule 10 Mg",
    "generic": "Lenvatinib Mesylate Eq. To",
    "strength": "12.25 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lenvatinib Capsule 10 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENVATINIB MESYLATE EQ. TO — 12.25 MG",
      "LENVATINIB — 10 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0179",
    "name": "Lenalidomide Capsules",
    "generic": "Lenalidomide",
    "strength": "5 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lenalidomide Capsules — Each hard gelatin capsule contains.",
    "composition": [
      "LENALIDOMIDE — 5 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0180",
    "name": "Enzalutamide Capsule 40 Mg",
    "generic": "Enzalutamide",
    "strength": "40 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Enzalutamide Capsule 40 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ENZALUTAMIDE — 40 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0181",
    "name": "Enzalutamide Capsule 80 Mg",
    "generic": "Enzalutamide",
    "strength": "80 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Enzalutamide Capsule 80 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ENZALUTAMIDE — 80 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0182",
    "name": "Nilotinib Capsule 200 Mg",
    "generic": "Nilotinib Hydrochloride Monohydrate",
    "strength": "200 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Nilotinib Capsule 200 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "NILOTINIB HYDROCHLORIDE MONOHYDRATE",
      "EQ. TO NILOTINIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0183",
    "name": "Nilotinib Capsule 150 Mg",
    "generic": "Nilotinib Hydrochloride Monohydrate",
    "strength": "150 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Nilotinib Capsule 150 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "NILOTINIB HYDROCHLORIDE MONOHYDRATE",
      "EQ. TO NILOTINIB — 150 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0184",
    "name": "Lomustine Capsule IP 40 Mg",
    "generic": "Lomustine",
    "strength": "40 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lomustine Capsule IP 40 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LOMUSTINE IP — 40 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0185",
    "name": "Lomustine Capsule IP 20 Mg",
    "generic": "Lomustine",
    "strength": "20 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Lomustine Capsule IP 20 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LOMUSTINE IP — 20 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0186",
    "name": "Acalabrutinib Capsule 100 Mg",
    "generic": "Acalabrutinib",
    "strength": "100 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Acalabrutinib Capsule 100 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ACALABRUTINIB IH — 100 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0187",
    "name": "Palbociclib Capsule 75 Mg",
    "generic": "Palbociclib",
    "strength": "75 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Palbociclib Capsule 75 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "PALBOCICLIB — 75 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0188",
    "name": "Palbociclib Capsule 100 Mg",
    "generic": "Palbociclib",
    "strength": "100 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Palbociclib Capsule 100 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "PALBOCICLIB — 100 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0189",
    "name": "Palbociclib Capsule 125 Mg",
    "generic": "Palbociclib",
    "strength": "125 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Palbociclib Capsule 125 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "PALBOCICLIB — 125 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0190",
    "name": "Estramustine Phosphate",
    "generic": "Estramustine Sodium Phosphate",
    "strength": "CAPSULE BP 140 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Estramustine Phosphate — Each hard gelatin capsule contains.",
    "composition": [
      "ESTRAMUSTINE SODIUM PHOSPHATE BP",
      "EQ. TO ESTRAMUSTINE PHOSPHATE — 140 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0191",
    "name": "Ibrutinib Capsule 140 Mg",
    "generic": "Ibrutinib",
    "strength": "140 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ibrutinib Capsule 140 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "IBRUTINIB — 140 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0192",
    "name": "Crizotinib Capsule 200 Mg",
    "generic": "Crizotinib",
    "strength": "200 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Crizotinib Capsule 200 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "CRIZOTINIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0193",
    "name": "Crizotinib Capsule 250 Mg",
    "generic": "Crizotinib",
    "strength": "250 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Crizotinib Capsule 250 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "CRIZOTINIB — 250 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0194",
    "name": "Ceritinib Capsules 150 Mg",
    "generic": "Ceritinib",
    "strength": "150 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ceritinib Capsules 150 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "CERITINIB — 150 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0195",
    "name": "Pomalidomide Capsule 1 Mg",
    "generic": "Pomalidomide",
    "strength": "1 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pomalidomide Capsule 1 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "POMALIDOMIDE — 1 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0196",
    "name": "Pomalidomide Capsule 3 Mg",
    "generic": "Pomalidomide",
    "strength": "3 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pomalidomide Capsule 3 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "POMALIDOMIDE — 3 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0197",
    "name": "Pomalidomide Capsule 4 Mg",
    "generic": "Pomalidomide",
    "strength": "4 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Pomalidomide Capsule 4 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "POMALIDOMIDE — 4 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0198",
    "name": "Procarbazine Capsules IP",
    "generic": "Procarbazine Hydrchloride",
    "strength": "50 MG",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Procarbazine Capsules IP — Each hard gelatin capsule contains.",
    "composition": [
      "PROCARBAZINE HYDRCHLORIDE IP",
      "EQ. TO PROCARBAZINE — 50 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0199",
    "name": "Cisplatin Inj. BP",
    "generic": "Cisplatin",
    "strength": "50 MG / 50 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cisplatin Inj. BP — Each ml contains.",
    "composition": [
      "CISPLATIN BP — 1 MG",
      "SODIUM CHLORIDE BP — 9 MG",
      "WATER FOR INNJ BP — Q.S."
    ]
  },
  {
    "id": "p0200",
    "name": "Cisplatin Inj. BP",
    "generic": "Cisplatin",
    "strength": "10 MG / 20 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cisplatin Inj. BP — Each ml contains.",
    "composition": [
      "CISPLATIN BP — 0.5 MG",
      "SODIUM CHLORIDE BP — 9 MG",
      "WATER FOR INNJ BP — Q.S."
    ]
  },
  {
    "id": "p0201",
    "name": "Paclitaxel Inj. USP",
    "generic": "Paclitaxel",
    "strength": "100 MG/16.7 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Paclitaxel Inj. USP — Each ml contains.",
    "composition": [
      "PACLITAXEL USP — 6 MG",
      "DEHYDRATED ALCOHOL USP — 49.7% V/V",
      "POLYOXYL 35 CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0202",
    "name": "Paclitaxel Inj. USP",
    "generic": "Paclitaxel",
    "strength": "260 MG/43.4 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Paclitaxel Inj. USP — Each ml contains.",
    "composition": [
      "PACLITAXEL USP — 6 MG",
      "DEHYDRATED ALCOHOL USP — 49.7% V/V",
      "POLYOXYL 35 CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0203",
    "name": "Docetaxel Concentrate Inj.",
    "generic": "1 Vial Docetaxel Inj.",
    "strength": "USP 80 MG (COMBI PACK)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Docetaxel Concentrate Inj. — Combipack contains.",
    "composition": [
      "1 VIAL DOCETAXEL INJ.",
      "DOCETAXEL TRIHYDRATE USP",
      "EQ. TO ANHYDROUS DOCETAXEL — 80 MG",
      "POLYSORBATE 80 USP — Q.S.",
      "1 VIAL OF SOLVENT FOR DOCETAXEL INJ",
      "ALCOHOL ( 95% V/V) USP — 13% V/V",
      "(ABSOLUTE ALCOHOL CONTENT 15.25% V/V)",
      "WATER FOR INJECTION USP — Q.S."
    ]
  },
  {
    "id": "p0204",
    "name": "Docetaxel Concentrate Inj.",
    "generic": "1 Vial Docetaxel Inj.",
    "strength": "USP 120 MG (COMBI PACK)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Docetaxel Concentrate Inj. — Combipack contains.",
    "composition": [
      "1 VIAL DOCETAXEL INJ.",
      "DOCETAXEL TRIHYDRATE USP",
      "EQ. TO ANHYDROUS DOCETAXEL — 120 MG",
      "POLYSORBATE 80 USP — Q.S.",
      "1 VIAL OF SOLVENT FOR DOCETAXEL INJ",
      "ALCOHOL ( 95% V/V) USP — 13% V/V",
      "(ABSOLUTE ALCOHOL CONTENT 15.25% V/V)",
      "WATER FOR INJECTION USP — Q.S."
    ]
  },
  {
    "id": "p0205",
    "name": "Zoledronic Acid Inj 4 Mg",
    "generic": "Zoledronic Acid Monohydrate Eq. To",
    "strength": "4 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Zoledronic Acid Inj 4 Mg — Each vial contains.",
    "composition": [
      "ZOLEDRONIC ACID MONOHYDRATE EQ. TO IH",
      "ZOLEDRONIC ACID — 4 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0206",
    "name": "Gemcitabine Inj USP 200 Mg",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Inj USP 200 Mg — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO USP — 200 MG",
      "GEMCITABINE",
      "MANNITOL USP — 200 MG",
      "SODIUM ACETATE USP — 12.5 MG",
      "WATER FOR INJECTION USP"
    ]
  },
  {
    "id": "p0207",
    "name": "Gemcitabine Inj USP 1000 Mg",
    "generic": "Gemcitabine Hydrochloride Eq. To",
    "strength": "1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Inj USP 1000 Mg — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE EQ. TO USP — 1000 MG",
      "GEMCITABINE",
      "MANNITOL USP — 1000 MG",
      "SODIUM ACETATE USP — 62.5 MG",
      "WATER FOR INJECTION USP — Q.S."
    ]
  },
  {
    "id": "p0208",
    "name": "Bortezomib For Innj 2 Mg",
    "generic": "Bortezumib",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Bortezomib For Innj 2 Mg — Each vial contains.",
    "composition": [
      "BORTEZUMIB IH — 2 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0209",
    "name": "Capacitabine Tablets USP",
    "generic": "Capecitabine",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Capacitabine Tablets USP — Each film coated tablet contains.",
    "composition": [
      "CAPECITABINE USP — 500 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR: APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0210",
    "name": "Capacitabine Tablets USP",
    "generic": "Capecitabine",
    "strength": "150 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Capacitabine Tablets USP — Each film coated tablet contains.",
    "composition": [
      "CAPECITABINE USP — 150 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR: APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0211",
    "name": "Anastrozole Tablets USP",
    "generic": "Anastrozole",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Anastrozole Tablets USP — Each film coated tablet contains.",
    "composition": [
      "ANASTROZOLE USP — 1 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR: APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0212",
    "name": "Temozolamide Capsules",
    "generic": "Temozolamide",
    "strength": "USP 20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide Capsules — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 20 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0213",
    "name": "Thalidomide Capsule USP",
    "generic": "Thalidomide",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Thalidomide Capsule USP — Each hard gelatin capsule contains.",
    "composition": [
      "THALIDOMIDE USP — 50 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0214",
    "name": "Etoposide Capsule USP",
    "generic": "Etoposide",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Etoposide Capsule USP — Each hard gelatin capsule contains.",
    "composition": [
      "ETOPOSIDE USP — 50 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0215",
    "name": "L-asparaginase For Injection",
    "generic": "L-asparaginase",
    "strength": "10000 IU",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "L-asparaginase For Injection — Each vial contains.",
    "composition": [
      "L-ASPARAGINASE — 10000 IU",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0216",
    "name": "L-asparaginase For Injection",
    "generic": "L-asparaginase",
    "strength": "5000 IU",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "L-asparaginase For Injection — Each vial contains.",
    "composition": [
      "L-ASPARAGINASE — 5000 IU",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0217",
    "name": "Leucovorin Calcium",
    "generic": "Calcium Folinate Eq. To Folinic Acid",
    "strength": "INJ. USP 100 MG/ 10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Leucovorin Calcium — Each ml contains.",
    "composition": [
      "CALCIUM FOLINATE EQ. TO FOLINIC ACID USP — 10 MG",
      "METHYLPARABEN BP — 0.08% W/V",
      "PROPYLPARABEN BP — 0.02% W/V",
      "WATER FOR INJECTION BP — Q.S."
    ]
  },
  {
    "id": "p0218",
    "name": "Fluorouracil Inj. USP",
    "generic": "Fluorouracil",
    "strength": "500 MG/ 10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Fluorouracil Inj. USP — Each ml contains.",
    "composition": [
      "FLUOROURACIL USP — 50 MG",
      "WATER FOR INJ. BP — Q.S."
    ]
  },
  {
    "id": "p0219",
    "name": "Bortezomib Inj. IP",
    "generic": "Bortezomib",
    "strength": "3.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Bortezomib Inj. IP — Each vial contains.",
    "composition": [
      "BORTEZOMIB IP — 3.5 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0220",
    "name": "Cytarabine Inj. BP",
    "generic": "Cytarabine",
    "strength": "100 MG/ 1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cytarabine Inj. BP — Each ml contains.",
    "composition": [
      "cytarabine BP — 100 MG",
      "WATER FOR INJ. — Q.S."
    ]
  },
  {
    "id": "p0221",
    "name": "Dacarbazine For Inj. USP",
    "generic": "Dacarbazine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Dacarbazine For Inj. USP — Each vial contains.",
    "composition": [
      "DACARBAZINE USP — 100 MG"
    ]
  },
  {
    "id": "p0222",
    "name": "Methotrexate Inj USP",
    "generic": "Methotrexate",
    "strength": "500 MG / 5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Methotrexate Inj USP — Each ml contains.",
    "composition": [
      "METHOTREXATE USP — 100 MG",
      "WATER FOR INJ. BP — Q.S."
    ]
  },
  {
    "id": "p0223",
    "name": "Methotrexate Inj USP",
    "generic": "Methotrexate",
    "strength": "50 MG / 2 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Methotrexate Inj USP — Each ml contains.",
    "composition": [
      "METHOTREXATE USP — 25 MG",
      "WATER FOR INJ. USP — Q.S.",
      "EACH VIAL CONTENTS:",
      "PEMETREXED DISODIUM HEPTAHYDRATE BP — 500 MG",
      "EQ. TO PEMETREXED — Q.S."
    ]
  },
  {
    "id": "p0224",
    "name": "Vinorelbine Inj. USP 50 Mg / 5 Ml",
    "generic": "Vinorelbine Tartrate Eq. To Vinorelbine",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Vinorelbine Inj. USP 50 Mg / 5 Ml — Each ml contains.",
    "composition": [
      "VINORELBINE TARTRATE EQ. TO VINORELBINE USP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0225",
    "name": "Mitomycin For Injection USP",
    "generic": "Mitomycin",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Mitomycin For Injection USP — Each vial contains.",
    "composition": [
      "MITOMYCIN USP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0226",
    "name": "Epirubicin Hydrochloride For Inj. 10 Mg",
    "generic": "Epirubicin Hydrochloride",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Epirubicin Hydrochloride For Inj. 10 Mg — Each vial contains.",
    "composition": [
      "EPIRUBICIN HYDROCHLORIDE BP — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0227",
    "name": "Epirubicin Hydrochloride For Inj. 50 Mg",
    "generic": "Epirubicin Hydrochloride",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Epirubicin Hydrochloride For Inj. 50 Mg — Each vial contains.",
    "composition": [
      "EPIRUBICIN HYDROCHLORIDE BP — 50 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0228",
    "name": "Busulphan Injection",
    "generic": "Busulphan",
    "strength": "60 MG/10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Busulphan Injection — Each vial contains.",
    "composition": [
      "BUSULPHAN IP — 60 MG",
      "N.N-DIMETHYLACITAMIDE IP — 3.3 ML",
      "POLYETHYLENE GLYCOL 400 IP — 6.7 ML"
    ]
  },
  {
    "id": "p0229",
    "name": "Doxorubicin Hydrochloride",
    "generic": "Doxorubicin Hydrochloride",
    "strength": "FOR INJ. USP 10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Doxorubicin Hydrochloride — Each vial contains.",
    "composition": [
      "DOXORUBICIN HYDROCHLORIDE USP — 10 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0230",
    "name": "Doxorubicin Hydrochloride",
    "generic": "Doxorubicin Hydrochloride",
    "strength": "FOR INJ. USP 50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Doxorubicin Hydrochloride — Each vial contains.",
    "composition": [
      "DOXORUBICIN HYDROCHLORIDE USP — 50 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0231",
    "name": "Thiotepa Injection BP 100 Mg",
    "generic": "Thiotepa",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Thiotepa Injection BP 100 Mg — Each vial contains.",
    "composition": [
      "THIOTEPA BP — 100 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0232",
    "name": "Epirubicin Hydrochloride Injection",
    "generic": "Epirubicin Hydrochloride",
    "strength": "(200MG/40 ML)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Epirubicin Hydrochloride Injection — Each ml contains.",
    "composition": [
      "EPIRUBICIN HYDROCHLORIDE USP — 5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0233",
    "name": "Paclitaxel Injection USP",
    "generic": "Paclitaxel",
    "strength": "300 MG/50 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Paclitaxel Injection USP — Each ml contains.",
    "composition": [
      "PACLITAXEL USP — 6 MG",
      "DEHYDRATED ALCOHOL USP — 49.7% V/V",
      "POLYOXYL 35 CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0234",
    "name": "Alectinib Capsules 150 Mg",
    "generic": "Alectinib Hydrochloride",
    "strength": "161.3 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Alectinib Capsules 150 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ALECTINIB HYDROCHLORIDE — 161.3 MG",
      "Eq. TO ALECTINIB — 150 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0235",
    "name": "Debrafenib Capsule 50 Mg",
    "generic": "Debrafenib Mesylate",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Debrafenib Capsule 50 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "DEBRAFENIB MESYLATE",
      "Eq. TO DEBRAFENIB — 50 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0236",
    "name": "Debrafenib Capsule 75 Mg",
    "generic": "Debrafenib Mesylate",
    "strength": "75 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Debrafenib Capsule 75 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "DEBRAFENIB MESYLATE",
      "Eq. TO DEBRAFENIB — 75 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0237",
    "name": "Trametinib Tablet 0.5 Mg",
    "generic": "Trametinib Dimethyl Sulfoxide",
    "strength": "0.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Trametinib Tablet 0.5 Mg — Each film coated tablet contains.",
    "composition": [
      "TRAMETINIB DIMETHYL SULFOXIDE",
      "EQ. TO TRAMETINIB — 0.5 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0238",
    "name": "Trametinib Tablet 2 Mg",
    "generic": "Trametinib Dimethyl Sulfoxide",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Trametinib Tablet 2 Mg — Each film coated tablet contains.",
    "composition": [
      "TRAMETINIB DIMETHYL SULFOXIDE",
      "EQ. TO TRAMETINIB — 2 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0239",
    "name": "Carboplatin Injection USP",
    "generic": "Carboplatin",
    "strength": "600 MG/60 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Carboplatin Injection USP — Each ml contains.",
    "composition": [
      "CARBOPLATIN USP — 10 MG",
      "WATER FOR INJECTION USP — Q.S."
    ]
  },
  {
    "id": "p0240",
    "name": "Nilotinib Capsule 200 Mg",
    "generic": "Nilotinib Hydrochloride Monohydrate",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Nilotinib Capsule 200 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "NILOTINIB HYDROCHLORIDE MONOHYDRATE",
      "EQ. TO NILOTINIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0241",
    "name": "Nilotinib Capsule 150 Mg",
    "generic": "Nilotinib Hydrochloride Monohydrate",
    "strength": "150 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Nilotinib Capsule 150 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "NILOTINIB HYDROCHLORIDE MONOHYDRATE",
      "EQ. TO NILOTINIB — 150 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0242",
    "name": "Metoxantrone Injection USP",
    "generic": "Mitoxantrone Hydrochloride",
    "strength": "10 MG/5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Metoxantrone Injection USP — Each ml contains.",
    "composition": [
      "MITOXANTRONE HYDROCHLORIDE USP",
      "EQ. TO MITOXANTRONE — 2 MG",
      "WATER FOR INJECTION USP — Q.S."
    ]
  },
  {
    "id": "p0243",
    "name": "Temozolamide Capsule USP 140 Mg",
    "generic": "Temozolamide",
    "strength": "140 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide Capsule USP 140 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 140 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0244",
    "name": "Temozolamide Capsule USP 180 Mg",
    "generic": "Temozolamide",
    "strength": "180 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide Capsule USP 180 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 180 MG",
      "EXCIPIENTS — Q.S.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0245",
    "name": "Docetaxel Injection USP 80 Mg/ 4 Ml",
    "generic": "Docetaxel Trihydrate",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Docetaxel Injection USP 80 Mg/ 4 Ml — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE USP",
      "EQ. TO ANHYDROUS DOCETAXEL — 20 MG",
      "POLYSORBATE 80 USP — 540 MG",
      "DEHYRATED ALCOHOL USP — 395 MG"
    ]
  },
  {
    "id": "p0246",
    "name": "Thiotepa For Injection BP 15 Mg",
    "generic": "Thiotepa",
    "strength": "15 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Thiotepa For Injection BP 15 Mg — Each vial contains.",
    "composition": [
      "THIOTEPA BP — 15 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0247",
    "name": "Estramustine Phosphate Capsule",
    "generic": "Estramustine Sodium Phosphate",
    "strength": "BP 140 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Estramustine Phosphate Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "ESTRAMUSTINE SODIUM PHOSPHATE BP",
      "Eq. ESTRAMUSTINE PHOSPHATE — 140 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0248",
    "name": "Mercaptopurine Tablet USP 50 Mg",
    "generic": "Mercaptopurine",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Mercaptopurine Tablet USP 50 Mg — Each uncoated tablet contains.",
    "composition": [
      "MERCAPTOPURINE USP — 50 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0249",
    "name": "Gemcitabine Injection 200 Mg/5.26 Ml",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "38 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Injection 200 Mg/5.26 Ml — Each ml contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP — 38 MG",
      "EQ. TO GEMCITABINE — Q.S.",
      "WATER FOR INJECTION"
    ]
  },
  {
    "id": "p0250",
    "name": "Gemcitabine Injection 1000 Mg/26.31 Ml",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "38 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Injection 1000 Mg/26.31 Ml — Each ml contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP — 38 MG",
      "EQ. TO GEMCITABINE — Q.S.",
      "WATER FOR INJECTION"
    ]
  },
  {
    "id": "p0251",
    "name": "Gemcitabine Injection 1400 Mg/36.84 Ml",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "38 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Injection 1400 Mg/36.84 Ml — Each ml contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP — 38 MG",
      "EQ. TO GEMCITABINE — Q.S.",
      "WATER FOR INJECTION"
    ]
  },
  {
    "id": "p0252",
    "name": "Dasatinib Tablets 50 Mg",
    "generic": "Dasatinib",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Dasatinib Tablets 50 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 50 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0253",
    "name": "Dasatinib Tablets 70 Mg",
    "generic": "Dasatinib",
    "strength": "70 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Dasatinib Tablets 70 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 70 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0254",
    "name": "Dasatinib Tablets 100 Mg",
    "generic": "Dasatinib",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Dasatinib Tablets 100 Mg — Each film coated tablet contains.",
    "composition": [
      "DASATINIB — 100 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0255",
    "name": "Lapatinib Tablets 250 Mg",
    "generic": "Lapatinib Ditosylate",
    "strength": "250 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Lapatinib Tablets 250 Mg — Each film coated tablet contains.",
    "composition": [
      "LAPATINIB DITOSYLATE — 250 MG",
      "EQ. TO LAPATINIB — Q.S.",
      "EXCIPIENTS",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0256",
    "name": "Cyclophosphamide For Injection",
    "generic": "Cyclophosphamide",
    "strength": "USP 200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cyclophosphamide For Injection — Each vial contains.",
    "composition": [
      "CYCLOPHOSPHAMIDE USP",
      "EQ TO ANHYDROUS CYCLOPHOSPHAMIDE — 200 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0257",
    "name": "Cyclophosphamide For Injection",
    "generic": "Cyclophosphamide",
    "strength": "USP 500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cyclophosphamide For Injection — Each vial contains.",
    "composition": [
      "CYCLOPHOSPHAMIDE USP",
      "EQ TO ANHYDROUS CYCLOPHOSPHAMIDE — 500 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0258",
    "name": "Cyclophosphamide For Injection",
    "generic": "Cyclophosphamide",
    "strength": "USP 1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cyclophosphamide For Injection — Each vial contains.",
    "composition": [
      "CYCLOPHOSPHAMIDE USP",
      "EQ TO ANHYDROUS CYCLOPHOSPHAMIDE — 1000 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0259",
    "name": "Cytarabine Inj. BP 50 Mg/5 Ml",
    "generic": "Cytarabine",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cytarabine Inj. BP 50 Mg/5 Ml — Each ml contains.",
    "composition": [
      "cytarabine BP — 10 MG",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0260",
    "name": "Methotrexate Inj. USP 1000 Mg/40 Ml",
    "generic": "Methotrexate",
    "strength": "25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Methotrexate Inj. USP 1000 Mg/40 Ml — Each ml contains.",
    "composition": [
      "METHOTREXATE USP — 25 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0261",
    "name": "Bleomycin For Injection USP 15 Units",
    "generic": "Bleomycin Sulfate",
    "strength": "15 UNITS",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Bleomycin For Injection USP 15 Units — Each vial contains.",
    "composition": [
      "BLEOMYCIN SULFATE USP",
      "EQ. TO BLEOMYCIN — 15 UNITS",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0262",
    "name": "Idarubicin Hydrochloride For",
    "generic": "Idarubicin Hydrochloride",
    "strength": "INJECTION USP 5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Idarubicin Hydrochloride For — Each vial contains.",
    "composition": [
      "IDARUBICIN HYDROCHLORIDE USP — 5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0263",
    "name": "Aprepitant Capsule BP 80 Mg",
    "generic": "Aprepitatnt",
    "strength": "80 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Aprepitant Capsule BP 80 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "APREPITATNT BP — 80 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0264",
    "name": "Aprepitant Capsule BP 125 Mg",
    "generic": "Aprepitatnt",
    "strength": "125 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Aprepitant Capsule BP 125 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "APREPITATNT BP — 125 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0265",
    "name": "Methorexate Tablet USP 2.5 Mg",
    "generic": "Methotrexate",
    "strength": "2.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Methorexate Tablet USP 2.5 Mg — Each uncoated tablet contains.",
    "composition": [
      "METHOTREXATE USP — 2.5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0266",
    "name": "Hydroxyurea Capsules USP 500 Mg",
    "generic": "Hydroxyurea",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Hydroxyurea Capsules USP 500 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "HYDROXYUREA USP — 500 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0267",
    "name": "Fluorouracil Injection USP 500 Mg/10 Ml",
    "generic": "Fluorouracil",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Fluorouracil Injection USP 500 Mg/10 Ml — Each ml contains.",
    "composition": [
      "FLUOROURACIL USP — 50 MG",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0268",
    "name": "Bortezomib Injection",
    "generic": "Bortezomib",
    "strength": "3.5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Bortezomib Injection — Each vial contains.",
    "composition": [
      "BORTEZOMIB — 3.5 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0269",
    "name": "Iforfamide For Injection USP 1gm",
    "generic": "Ifosfamide",
    "strength": "1GM",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Iforfamide For Injection USP 1gm — Each vial contains.",
    "composition": [
      "IFOSFAMIDE USP — 1GM",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0270",
    "name": "Melphalan Tablet USP 2 Mg",
    "generic": "Melphalan",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Melphalan Tablet USP 2 Mg — Each film coated tablet contains.",
    "composition": [
      "MELPHALAN USP — 2 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0271",
    "name": "Chlorambucil Tablet USP 2 Mg",
    "generic": "Chlorambucil",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Chlorambucil Tablet USP 2 Mg — Each film coated tablet contains.",
    "composition": [
      "CHLORAMBUCIL USP — 2 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0272",
    "name": "Dacarbazine For Injection USP 200 Mg",
    "generic": "Dacarbazine",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Dacarbazine For Injection USP 200 Mg — Each vial contains.",
    "composition": [
      "DACARBAZINE USP — 200 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0273",
    "name": "Pemetrexed For Injection USP 500 Mg",
    "generic": "Pemetrexed Disodium",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Pemetrexed For Injection USP 500 Mg — Each vial contains.",
    "composition": [
      "PEMETREXED DISODIUM USP",
      "EQ. TO PEMETREXED — 500 MG",
      "MANNITOL USP — 500 MG"
    ]
  },
  {
    "id": "p0274",
    "name": "Azacitadine For Injection 100 Mg",
    "generic": "Azacitadine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Azacitadine For Injection 100 Mg — Each vial contains.",
    "composition": [
      "AZACITADINE IH — 100 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0275",
    "name": "Pazopanib Hydrochloride Tablet",
    "generic": "Pazopanib Hydrochloride",
    "strength": "400 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Pazopanib Hydrochloride Tablet — Each film coated tablet contains.",
    "composition": [
      "PAZOPANIB HYDROCHLORIDE IH",
      "EQ. TO PAZOPANIB — 400 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0276",
    "name": "Tamoxifen Citrate Tablet USP 10 Mg",
    "generic": "Tamoxifen Citrate",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Tamoxifen Citrate Tablet USP 10 Mg — Each uncoated tablet contains.",
    "composition": [
      "TAMOXIFEN CITRATE USP",
      "EQ. TO TAMOXIFEN — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0277",
    "name": "Tamoxifen Citrate Tablet USP 20 Mg",
    "generic": "Tamoxifen Citrate",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Tamoxifen Citrate Tablet USP 20 Mg — Each uncoated tablet contains.",
    "composition": [
      "TAMOXIFEN CITRATE USP",
      "EQ. TO TAMOXIFEN — 20 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0278",
    "name": "Olaparib Tablet 150 Mg",
    "generic": "Olaparib",
    "strength": "150 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Olaparib Tablet 150 Mg — Each film coated tablet contains.",
    "composition": [
      "OLAPARIB IH — 150 MG",
      "EXCIPIENTS — Q.S.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0279",
    "name": "Vinorelbine Injection USP 10 Mg/ 1 Ml",
    "generic": "Vinorelbine Tartrate",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Vinorelbine Injection USP 10 Mg/ 1 Ml — Each ml contains.",
    "composition": [
      "VINORELBINE TARTRATE USP",
      "EQ. TO VINORELBINE — 10 MG",
      "EXCIPIENTS — Q.S."
    ]
  },
  {
    "id": "p0280",
    "name": "Sorafenib Tosylate",
    "generic": "Sorafenib Tosylate",
    "strength": "SORAFENIB TABLET BP 200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Sorafenib Tosylate — Each film coated tablet contains.",
    "composition": [
      "SORAFENIB TOSYLATE BP",
      "EQ. TO SORAFENIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0281",
    "name": "Dacarbazine For Injection USP 500 Mg",
    "generic": "Dacarbazine",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Dacarbazine For Injection USP 500 Mg — Each vial contains.",
    "composition": [
      "DACARBAZINE USP — 500 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0282",
    "name": "Palonosetron Hydrochloride Injection",
    "generic": "Palonosetron Hydrochloride",
    "strength": "0.25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Palonosetron Hydrochloride Injection — Each 5 ml vial contains.",
    "composition": [
      "PALONOSETRON HYDROCHLORIDE USP",
      "EQ. TO PALONOSETRON — 0.25 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0283",
    "name": "Oxaliplatin Injection USP",
    "generic": "Oxaliplatin",
    "strength": "50 MG/10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Oxaliplatin Injection USP — Each ml contains.",
    "composition": [
      "OXALIPLATIN USP — 5 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0284",
    "name": "Oxaliplatin Injection USP",
    "generic": "Oxaliplatin",
    "strength": "100 MG/20 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Oxaliplatin Injection USP — Each ml contains.",
    "composition": [
      "OXALIPLATIN USP — 5 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0285",
    "name": "Ifosfamide For Injection USP 2g With",
    "generic": "1 Vial Ifosfamide Injection",
    "strength": "2G",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Ifosfamide For Injection USP 2g With — Combipack contains.",
    "composition": [
      "1 VIAL IFOSFAMIDE INJECTION",
      "IFOSFAMIDE USP — 2G",
      "EXCIPIENTS",
      "1 VIAL MESNA INJECTION",
      "EACH ML CONTAINS:",
      "MESNA USP — 100 MG"
    ]
  },
  {
    "id": "p0286",
    "name": "Cytarabine Injection BP 500 Mg/5 Ml",
    "generic": "Cytarabine",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cytarabine Injection BP 500 Mg/5 Ml — Each ml contains.",
    "composition": [
      "CYTARABINE BP — 100 MG",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0287",
    "name": "Megestrol Acetate Tablets USP 40 Mg",
    "generic": "Megestrol Acetate",
    "strength": "40 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Megestrol Acetate Tablets USP 40 Mg — Each uncoated tablet contains.",
    "composition": [
      "MEGESTROL ACETATE USP — 40 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0288",
    "name": "Daunorubicin Injection USP 20 Mg",
    "generic": "Daunorubicin Hydrochloride",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Daunorubicin Injection USP 20 Mg — Each vial contains.",
    "composition": [
      "DAUNORUBICIN HYDROCHLORIDE USP",
      "EQ. TO DAUNORUBICIN — 20 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0289",
    "name": "Lenalidomide Capsules 5 Mg",
    "generic": "Lenalidomide",
    "strength": "5 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Lenalidomide Capsules 5 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENALIDOMIDE IH — 5 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0290",
    "name": "Leucovorin Calcium Tablets USP",
    "generic": "Leucovorin Calcium",
    "strength": "15 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Leucovorin Calcium Tablets USP — Each film coated tablet contains.",
    "composition": [
      "LEUCOVORIN CALCIUM IP",
      "EQ. TO LEUCOVORIN — 15 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR : APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0291",
    "name": "Aprepitant Capsule USP 80 Mg",
    "generic": "Aprepitatnt",
    "strength": "80 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Aprepitant Capsule USP 80 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "APREPITATNT USP — 80 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0292",
    "name": "Aprepitant Capsule USP 125 Mg",
    "generic": "Aprepitatnt",
    "strength": "125 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Aprepitant Capsule USP 125 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "APREPITATNT USP — 125 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0293",
    "name": "Aprepitant Capsule USP 80 Mg/125 Mg",
    "generic": "1 Capsule Aprepitant",
    "strength": "125 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Aprepitant Capsule USP 80 Mg/125 Mg — Combipack contains.",
    "composition": [
      "1 CAPSULE APREPITANT USP — 125 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL",
      "2 CAPSULE APREPITANT USP — 80 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0294",
    "name": "Methotrexate Tablet USP 10 Mg",
    "generic": "Methotrexate",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Methotrexate Tablet USP 10 Mg — Each uncoated tablet contains.",
    "composition": [
      "METHOTREXATE USP — 10 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0295",
    "name": "Cisplatin Injection BP",
    "generic": "Cisplatin",
    "strength": "50 MG / 50 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cisplatin Injection BP — Each ml contains.",
    "composition": [
      "CISPLATIN BP — 1 MG",
      "SODIUM CHLORIDE BP — 9 MG",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0296",
    "name": "Cisplatin Injection BP",
    "generic": "Cisplatin",
    "strength": "10 MG / 20 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cisplatin Injection BP — Each ml contains.",
    "composition": [
      "CISPLATIN BP — 0.5 MG",
      "SODIUM CHLORIDE BP — 9 MG",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0297",
    "name": "Paclitaxel Injection USP",
    "generic": "Paclitaxel",
    "strength": "260 MG / 43.4 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Paclitaxel Injection USP — Each ml contains.",
    "composition": [
      "PACLITAXEL USP — 6 MG",
      "DEHYRATED ALCOHOL USP — 49.7% V/V",
      "POLYOXYL 35 CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0298",
    "name": "Zoldronic Acid Injection",
    "generic": "Zoldronic Acid Monohydrate",
    "strength": "4 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Zoldronic Acid Injection — Each vial contains.",
    "composition": [
      "ZOLDRONIC ACID MONOHYDRATE IH",
      "EQ. ZOLDRONIC ACID — 4 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0299",
    "name": "Gemcitabine Injection",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "USP 200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Injection — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP — 200 MG",
      "EQ. GEMCITABINE",
      "MANNITOL USP — 200 MG",
      "SODIUM ACETATE USP — 12.5 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0300",
    "name": "Gemcitabine Injection",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "USP 1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Injection — Each vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP — 1000 MG",
      "EQ. GEMCITABINE",
      "MANNITOL USP — 1000 MG",
      "SODIUM ACETATE USP — 62.5 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0301",
    "name": "Leucovorin Calcium",
    "generic": "Leucovorin Calcium",
    "strength": "INJECTION USP 50 MG / 5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Leucovorin Calcium — Each ml contains.",
    "composition": [
      "LEUCOVORIN CALCIUM USP",
      "EQ. TO LEUCOVORIN — 10 MG",
      "METHYLPARABEN BP — 0.08% W/V",
      "PROPYLPARABEN BP — 0.02% W/V",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0302",
    "name": "Leucovorin Calcium",
    "generic": "Leucovorin Calcium",
    "strength": "INJECTION USP 100 MG / 10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Leucovorin Calcium — Each ml contains.",
    "composition": [
      "LEUCOVORIN CALCIUM USP",
      "EQ. TO LEUCOVORIN — 10 MG",
      "METHYLPARABEN BP — 0.08% W/V",
      "PROPYLPARABEN BP — 0.02% W/V",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0303",
    "name": "Vincristine Sulphate Injection",
    "generic": "Vincristine Sulphate",
    "strength": "USP 1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Vincristine Sulphate Injection — Each ml contains.",
    "composition": [
      "VINCRISTINE SULPHATE USP — 1 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0304",
    "name": "Etoposide Injection USP",
    "generic": "Etoposide",
    "strength": "100 MG / 5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Etoposide Injection USP — Each ml contains.",
    "composition": [
      "ETOPOSIDE USP — 20 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0305",
    "name": "Abiraterone Acetate Tablet",
    "generic": "Abiraterone Acetate",
    "strength": "USP 250 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Abiraterone Acetate Tablet — Each uncoated tablet contains.",
    "composition": [
      "ABIRATERONE ACETATE USP — 250 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0306",
    "name": "Abiraterone Acetate Tablet",
    "generic": "Abiraterone Acetate",
    "strength": "USP 500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Abiraterone Acetate Tablet — Each uncoated tablet contains.",
    "composition": [
      "ABIRATERONE ACETATE USP — 500 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0307",
    "name": "Carfilzomib For Injection",
    "generic": "Carfilzomib",
    "strength": "60 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Carfilzomib For Injection — Each vial contains.",
    "composition": [
      "CARFILZOMIB — 60 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0308",
    "name": "Bendamustine Hydrochloride",
    "generic": "Bendamustine Hydrochloride",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Bendamustine Hydrochloride — Each vial contains.",
    "composition": [
      "BENDAMUSTINE HYDROCHLORIDE USP — 100 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0309",
    "name": "Busulphan Injection",
    "generic": "Busulphan",
    "strength": "60 MG / 10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Busulphan Injection — Each vial contains.",
    "composition": [
      "BUSULPHAN BP — 60 MG",
      "N,N-DIMETHYLACETAMIDE BP — 3.3 ML",
      "POLYETHELYNE GLYCOL 400 USNF — 6.7 ML"
    ]
  },
  {
    "id": "p0310",
    "name": "Enzalutamide Capsule 40 Mg",
    "generic": "Enzalutamide",
    "strength": "40 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Enzalutamide Capsule 40 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ENZALUTAMIDE — 40 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0311",
    "name": "Temozolamide Capsule",
    "generic": "Temozolamide",
    "strength": "USP 100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 100 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0312",
    "name": "Carboplatin Injection BP",
    "generic": "Carboplatin",
    "strength": "150 MG / 15 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Carboplatin Injection BP — Each ml contains.",
    "composition": [
      "CARBOPLATIN BP — 10 MG",
      "WATER FOR INJECTION BP — q.s."
    ]
  },
  {
    "id": "p0313",
    "name": "Thiotepa Injection BP 100 Mg",
    "generic": "Thiotepa",
    "strength": "100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Thiotepa Injection BP 100 Mg — Each vial contains.",
    "composition": [
      "THIOTEPA BP — 100 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0314",
    "name": "Bortezomib For Injection 2 Mg",
    "generic": "Bortezomib",
    "strength": "2 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Bortezomib For Injection 2 Mg — Each vial contains.",
    "composition": [
      "BORTEZOMIB IH — 2 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0315",
    "name": "Anastrazole Tablet USP 1 Mg",
    "generic": "Anastrazole",
    "strength": "1 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Anastrazole Tablet USP 1 Mg — Each film coated tablet contains.",
    "composition": [
      "ANASTRAZOLE USP — 1 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR:APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0316",
    "name": "Temozolamide Capsule",
    "generic": "Temozolamide",
    "strength": "USP 20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 20 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0317",
    "name": "Temozolamide Capsule",
    "generic": "Temozolamide",
    "strength": "USP 100 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide Capsule — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 100 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0318",
    "name": "Oxaliplatin Injection",
    "generic": "Oxaliplatin",
    "strength": "USP 100 MG / 50 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Oxaliplatin Injection — Eacl ml contain.",
    "composition": [
      "OXALIPLATIN USP — 2 MG",
      "EXCIPIENTS USP — q.s."
    ]
  },
  {
    "id": "p0319",
    "name": "Docetaxel Injection USP",
    "generic": "Docetaxel Trihydrate",
    "strength": "80 MG / 4 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Docetaxel Injection USP — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE USP",
      "EQ. TO ANHYDROUS DOCETAXEL — 20 MG",
      "POLYSORBATE 80 USP — 540 MG",
      "DEHYRATED ALCOHOL USP — 395 MG"
    ]
  },
  {
    "id": "p0320",
    "name": "Mitoxantrone Injection USP",
    "generic": "Motoxantrone Hydrochloride",
    "strength": "10 MG/5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Mitoxantrone Injection USP — Each ml contains.",
    "composition": [
      "MOTOXANTRONE HYDROCHLORIDE USP",
      "EQ. TO MITOXANTRONE — 2 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0321",
    "name": "Gemcitabine Hydrochloride USP 200 Mg",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Hydrochloride USP 200 Mg — Eaich vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP",
      "EQ. GEMCITABINE — 200 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0322",
    "name": "Gemcitabine Hydrochloride USP 1000 Mg",
    "generic": "Gemcitabine Hydrochloride",
    "strength": "1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Gemcitabine Hydrochloride USP 1000 Mg — Eaich vial contains.",
    "composition": [
      "GEMCITABINE HYDROCHLORIDE USP",
      "EQ. GEMCITABINE — 1000 MG",
      "EXCIPIENTS — q.s."
    ]
  },
  {
    "id": "p0323",
    "name": "Paclitaxel 300 Mg/50 Ml",
    "generic": "Paclitaxel",
    "strength": "6 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Paclitaxel 300 Mg/50 Ml — Each ml contains.",
    "composition": [
      "PACLITAXEL USP — 6 MG",
      "DEHYDRATED ALCOHOL USP — 49.7% V/V",
      "POLYOXYL 35 CASTOR OIL USNF — 527 MG"
    ]
  },
  {
    "id": "p0324",
    "name": "Docetaxel Trihydrate 120 Mg / 6 Ml",
    "generic": "Docetaxel Trihydrate",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Docetaxel Trihydrate 120 Mg / 6 Ml — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE USP",
      "EQ. TO ANHYDROUS DOCETAXEL — 20 MG",
      "POLYSORBATE 80 USP — 540 MG",
      "DEHYDRATED ALCOHOL USP — 395 MG"
    ]
  },
  {
    "id": "p0325",
    "name": "Sorafenib Tablet BP 200 Mg",
    "generic": "Sorafenib Tosylate",
    "strength": "200 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Sorafenib Tablet BP 200 Mg — Each film coated tablet contains.",
    "composition": [
      "SORAFENIB TOSYLATE BP",
      "EQ. TO SORAFENIB — 200 MG",
      "EXCIPIENTS — q.s.",
      "COLOUR:APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0326",
    "name": "Lenvatinib Capsule 4 Mg",
    "generic": "Lenvatinib Mesylate",
    "strength": "4.90 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Lenvatinib Capsule 4 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENVATINIB MESYLATE IH — 4.90 MG",
      "EQ. TO LENVATINIB — 4 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0327",
    "name": "Lenvatinib Capsule 10 Mg",
    "generic": "Lenvatinib Mesylate",
    "strength": "12.25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Lenvatinib Capsule 10 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENVATINIB MESYLATE IH — 12.25 MG",
      "EQ. TO LENVATINIB — 10 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0328",
    "name": "Lenalidomide Capsules 10 Mg",
    "generic": "Lenalidomide",
    "strength": "10 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Lenalidomide Capsules 10 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENALIDOMIDE IH — 10 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0329",
    "name": "Lenalidomide Capsules 25 Mg",
    "generic": "Lenalidomide",
    "strength": "25 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Lenalidomide Capsules 25 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "LENALIDOMIDE IH — 25 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0330",
    "name": "Oxaliplatin Injection USP",
    "generic": "Oxaliplatin",
    "strength": "50 MG/25 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Oxaliplatin Injection USP — Each ml contains.",
    "composition": [
      "OXALIPLATIN USP — 2 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0331",
    "name": "Oxaliplatin Injection USP",
    "generic": "Oxaliplatin",
    "strength": "100 MG/50 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Oxaliplatin Injection USP — Each ml contains.",
    "composition": [
      "OXALIPLATIN USP — 2 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0332",
    "name": "Cafrboplatin Injection USP",
    "generic": "Carboplatin",
    "strength": "150 MG/15 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cafrboplatin Injection USP — Each ml contains.",
    "composition": [
      "CARBOPLATIN USP — 10 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0333",
    "name": "Cafrboplatin Injection USP",
    "generic": "Carboplatin",
    "strength": "450 MG/45 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Cafrboplatin Injection USP — Each ml contains.",
    "composition": [
      "CARBOPLATIN USP — 10 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0334",
    "name": "Docetaxel Injection USP",
    "generic": "Docetaxel Trihydrate",
    "strength": "80 MG/4 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Docetaxel Injection USP — Each ml contains.",
    "composition": [
      "DOCETAXEL TRIHYDRATE USP",
      "EQ. TO ANHYDROUS DOCETAXEL — 20 MG",
      "POLYSORBATE 80 USP — 540 MG",
      "DEHYDRATED ALCOHOL USP — 395 MG"
    ]
  },
  {
    "id": "p0335",
    "name": "Methotrexate Injection USP",
    "generic": "Methotrexate",
    "strength": "50 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Methotrexate Injection USP — Each ml contains.",
    "composition": [
      "METHOTREXATE USP — 25 MG",
      "WATER FOR INJECTION USP — q.s."
    ]
  },
  {
    "id": "p0336",
    "name": "Capecitabine Tablet USP",
    "generic": "Capecitabine",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Capecitabine Tablet USP — Each film coated tablet contains.",
    "composition": [
      "CAPECITABINE USP — 500 MG",
      "EXCIPIENTS",
      "COLOUR:APPROVED COLOUR USED IN COATING"
    ]
  },
  {
    "id": "p0337",
    "name": "Temozolamide USP 20 Mg",
    "generic": "Temozolamide",
    "strength": "20 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Temozolamide USP 20 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "TEMOZOLAMIDE USP — 20 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0338",
    "name": "Palbociclib Capsule 125 Mg",
    "generic": "Palbociclib",
    "strength": "125 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Palbociclib Capsule 125 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "PALBOCICLIB — 125 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0339",
    "name": "Enzalutamide Capsule 40 Mg",
    "generic": "Enzalutamide",
    "strength": "40 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "Export pack (as per market requirement)",
    "desc": "Enzalutamide Capsule 40 Mg — Each hard gelatin capsule contains.",
    "composition": [
      "ENZALUTAMIDE — 40 MG",
      "EXCIPIENTS — q.s.",
      "APPROVED COLOUR USED IN CAPSULE SHELL"
    ]
  },
  {
    "id": "p0340",
    "name": "Methylcobalamin Injection",
    "generic": "Methylcobalamin Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin Injection (Domestic).",
    "composition": [
      "Each ml contains",
      "Methylcobalamin IP - 1500 mcg",
      "Benzyl Alcohol IP - .2% v/v",
      "(As per preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0341",
    "name": "Methylcobalamin, Vitamin B6 &nicotinamide Injection",
    "generic": "Methylcobalamin",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin, Vitamin B6 &nicotinamide Injection (Domestic).",
    "composition": [
      "Each 2 ml contains",
      "Methylcobalamin IP - 1000 mcg",
      "Vitamin B6 IP - 100 mg",
      "Nicotinamide IP - 100 mg",
      "Benzyl Alcohol IP - 2% v/v",
      "(as preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0342",
    "name": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxin Hydrochloride, Niacinamide & D-panthenol Injection",
    "generic": "Methylcobalamin",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxin Hydrochloride, Niacinamide & D-panthenol Injection (Domestic).",
    "composition": [
      "Each 2 ml contains",
      "Methylcobalamin IP - 1500 mcg",
      "Thiamine Hydrochloride IP - 100 mg",
      "Pyridoxin Hydrochloride IP - 100 mg",
      "Niacinamide IP - 100 mg",
      "D-Panthenol IP - .50 mg",
      "Benzyl Alcohol IP - .2% v/v",
      "(as preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0343",
    "name": "Diclofenac Injection IP 3ml",
    "generic": "Diclofenac Injection IP 3ml",
    "strength": "3ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Diclofenac Injection IP 3ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Diclofenac Sodium IP - 25 mg",
      "Benzyl Alcohol IP - .4% v/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0344",
    "name": "Diclofenac Injection IP 1ml",
    "generic": "Diclofenac Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Diclofenac Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Diclofenac Sodium IP - .75 mg",
      "Benzyl Alcohol IP - .4% v/v",
      "(As Preservative)",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0345",
    "name": "Ondansetron Injection IP 2ml",
    "generic": "Ondansetron Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Ondansetron Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ondansetron hydrochloride IP",
      "Eq. to Ondansetron - 2 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0346",
    "name": "Ranitidine Hydrochloride Injection 2ml",
    "generic": "Ranitidine Hydrochloride Injection 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Ranitidine Hydrochloride Injection 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ranitidine hydrochloride IP",
      "Eq. to Ranitidine - .25 mg",
      "Phenol IP - .0.5 % w/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0347",
    "name": "Drotaverine Injection 2ml",
    "generic": "Drotaverine Injection 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Drotaverine Injection 2ml (Domestic).",
    "composition": [
      "Each 2ml contains:",
      "Drotaverine hydrochloride IP - 40 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0348",
    "name": "Piroxicam Injection 2ml",
    "generic": "Piroxicam Injection 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Piroxicam Injection 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Piroxicam IP - .20 mg",
      "Benzyl Alcohol IP - 2% v/v",
      "(As preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0349",
    "name": "Paracetamol Injection 2ml",
    "generic": "Paracetamol Injection 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Paracetamol Injection 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Paracetamol IP - 150 mg",
      "Benzyl Alcohol IP - .2%",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0350",
    "name": "Ketorolac Tromethamine Injection IP 1ml",
    "generic": "Ketorolac Tromethamine Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Ketorolac Tromethamine Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ketorolac Tromethamine IP - 30 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0351",
    "name": "Betamethasone Injection IP 1ml",
    "generic": "Betamethasone Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Betamethasone Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Betamethasone sodium phosphate IP",
      "Eq. to Betamethasone - .4 mg",
      "Phenol IP - 0.5% w/v",
      "(As Preservative)",
      "Water for Injections - . q.s."
    ]
  },
  {
    "id": "p0352",
    "name": "Frusemide Injection IP 2ml",
    "generic": "Frusemide Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Frusemide Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Frusemide IP - 10 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0353",
    "name": "Metoclopramide Injection IP 2ml",
    "generic": "Metoclopramide Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Metoclopramide Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Metoclopramide hydrochloride IP",
      "Eq. to Metoclopramide (Anhydrous) - . 5 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0354",
    "name": "Iron Sucrose Injection USP 5 Ml",
    "generic": "Iron Sucrose Injection USP 5 Ml",
    "strength": "5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Iron Sucrose Injection USP 5 Ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ferric Hydroxide in Complex with Sucrose",
      "Eq. to Elemental Iron - .20 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0355",
    "name": "Injection Of Etofyllin And Theophyllin 2 Ml",
    "generic": "Injection Of Etofyllin And Theophyllin 2 Ml",
    "strength": "2 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Injection Of Etofyllin And Theophyllin 2 Ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Etofyllin BP - .84.7 mg",
      "Theophyllin IP (Anhydrous)",
      "Eq. to Theophyllin IP - 25.3 mg",
      "(Hydrate)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0356",
    "name": "Α-β Arteether Injection 2ml",
    "generic": "Α-β Arteether Injection 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Α-β Arteether Injection 2ml (Domestic).",
    "composition": [
      "Each 2ml contains:",
      "α-β Arteether IP - 150 mg",
      "Oily base - q.s."
    ]
  },
  {
    "id": "p0357",
    "name": "Cholecalciferol Injection IP 1ml Vitamin D3",
    "generic": "Cholecalciferol Injection IP 1ml Vitamin D3",
    "strength": "1ML VITAMIN D3",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Cholecalciferol Injection IP 1ml Vitamin D3 (Domestic).",
    "composition": [
      "Each ml contains:",
      "Cholecalciferol IP - 6000000 IU",
      "(15MG)",
      "Arachis Oil BP - .q.s."
    ]
  },
  {
    "id": "p0358",
    "name": "Cholecalciferol Injection IP 1 Ml Vitamin D3",
    "generic": "Cholecalciferol Injection IP 1 Ml Vitamin D3",
    "strength": "1 ML VITAMIN D3",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Cholecalciferol Injection IP 1 Ml Vitamin D3 (Domestic).",
    "composition": [
      "Each ml contains:",
      "Cholecalciferol IP - .3000000 IU",
      "(7.5MG)",
      "Arachis Oil IP - q.s."
    ]
  },
  {
    "id": "p0359",
    "name": "Citicoline Injection IP 2ml",
    "generic": "Citicoline Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Domestic pack",
    "desc": "Citicoline Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Citicoline sodium IP",
      "Eq. to Citicoline - . 250mg",
      "Methyl paraben IP - 0.18%w/v",
      "(As preservative)",
      "Propyl Paraben IP - 0.02%w/v",
      "(As preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0360",
    "name": "Citicoline Injection IP 4ml",
    "generic": "Citicoline Injection IP 4ml",
    "strength": "4ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Domestic pack",
    "desc": "Citicoline Injection IP 4ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Citicoline sodium IP",
      "Eq. to Citicoline - .250 mg",
      "Methyl paraben IP - 0.18%w/v",
      "(As preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0361",
    "name": "Etamsylate Injection 2ml",
    "generic": "Etamsylate Injection 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Etamsylate Injection 2ml (Domestic).",
    "composition": [
      "Each 2ml contains:",
      "Etamsylate BP - . 250 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0362",
    "name": "Pheniramine Maleate Injection IP 2ml",
    "generic": "Pheniramine Maleate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Pheniramine Maleate Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Pheniramine maleate IP - 22.75mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0363",
    "name": "Promethazine Hydrochloride Injection IP 2ml",
    "generic": "Promethazine Hydrochloride Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Promethazine Hydrochloride Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Promethazine HCL IP - .25mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0364",
    "name": "Dicyclomine Injection IP 2ml",
    "generic": "Dicyclomine Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Dicyclomine Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dicyclomine Hydrochloride IP - .10mg",
      "Chlorbutol IP - 0.5%w/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0365",
    "name": "Hyoscine Butyl Bromide Injection IP",
    "generic": "Hyoscine Butyl Bromide Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Hyoscine Butyl Bromide Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Hyoscine Butyl Bromide IP - 20mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0366",
    "name": "Artemether Injection 1ml",
    "generic": "Artemether Injection 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Artemether Injection 1ml (Domestic).",
    "composition": [
      "Each ml contains",
      "Artemether IP - . - 40mg",
      "Oil base - q.s."
    ]
  },
  {
    "id": "p0367",
    "name": "Artemether Injection 1ml",
    "generic": "Artemether Injection 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Artemether Injection 1ml (Domestic).",
    "composition": [
      "Each ml contains",
      "Artemether IP - 80mg",
      "Oil base - . q.s."
    ]
  },
  {
    "id": "p0368",
    "name": "Amikacin Sulphate Injection IP 2ml",
    "generic": "Amikacin Sulphate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP 2ml (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Amikacin Sulphate IP",
      "Eq. to Amikacin - 500mg",
      "Water for Injection IP - q.s.",
      "Also contains",
      "Buffering agent",
      "Sodium citrate IP - 2.5%w/v",
      "Preservatives:",
      "Sodium Metabisulphite IP - . 0.66%w/v",
      "Methyl Paraben IP - .0.04%w/v",
      "Propyl paraben IP - 0.01%w/v"
    ]
  },
  {
    "id": "p0369",
    "name": "Amikacin Sulphate Injection IP 2ml",
    "generic": "Amikacin Sulphate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP 2ml (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Amikacin Sulphate IP",
      "Eq. to Amikacin - 250mg",
      "Water for Injections IP - q.s.",
      "Also contains",
      "Buffering agent",
      "Sodium citrate IP - 1.25%w/v",
      "Preservatives:",
      "Sodium Metabisulphite IP - .0.33%w/v",
      "Methyl Paraben IP - 0.08%w/v",
      "Propyl paraben IP - 0.02%w/v"
    ]
  },
  {
    "id": "p0370",
    "name": "Amikacin Sulphate Injection IP 2ml",
    "generic": "Amikacin Sulphate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP 2ml (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Amikacin Sulphate IP",
      "Eq. to Amikacin - . 100mg",
      "Water for Injections IP - q.s.",
      "Also contains",
      "Buffering agent",
      "Sodium citrate IP - .0.5%w/v",
      "Preservatives:",
      "Sodium Metabisulphite IP - . - . 0.66%w/v",
      "Methyl Paraben IP - . - 0.08%w/v",
      "Propyl paraben IP - .0.08%w/v"
    ]
  },
  {
    "id": "p0371",
    "name": "Amikacin Sulphate Injection IP 2ml",
    "generic": "Amikacin Sulphate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP 2ml (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Amikacin Sulphate IP",
      "Eq. to Amikacin - 500mg",
      "Methyl Paraben IP - .0.04%w/v",
      "(As Preservative)",
      "Propyl paraben IP - .0.01%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0372",
    "name": "Amikacin Sulphate Injection IP 2ml",
    "generic": "Amikacin Sulphate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP 2ml (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Amikacin Sulphate IP",
      "Eq. to Amikacin - 250mg",
      "Methyl Paraben IP - .0.08%w/v",
      "(As Preservative)",
      "Propyl paraben IP - . - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - .q.s."
    ]
  },
  {
    "id": "p0373",
    "name": "Amikacin Sulphate Injection IP 2ml",
    "generic": "Amikacin Sulphate Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP 2ml (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Amikacin Sulphate IP",
      "Eq. to Amikacin - .100mg",
      "Methyl Paraben IP - .0.08%w/v",
      "(As Preservative)",
      "Propyl paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0374",
    "name": "Triamcinolone Acetonide Injection IP 1ml",
    "generic": "Triamcinolone Acetonide Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "Domestic pack",
    "desc": "Triamcinolone Acetonide Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Triamcinolone Acetonide IP - .40mg",
      "Benzyl Alcohol IP - 0.9%v/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0375",
    "name": "Dexamethasone Injection IP 2ml",
    "generic": "Dexamethasone Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dexamethasone Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dexamethasone sodium phosphate IP",
      "Eq. to Dexamethasone phosphate - .4.0mg",
      "Methyl Paraben IP - . - 0.15%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - . 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - . - . q.s."
    ]
  },
  {
    "id": "p0376",
    "name": "Gentamycin Injection IP 2ml",
    "generic": "Gentamycin Injection IP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamycin Injection IP 2ml (Domestic).",
    "composition": [
      "Each ml contains",
      "Gentamicin Sulphate IP",
      "Eq. to Gentamicin - 40mg",
      "Methyl Paraben IP - 0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0377",
    "name": "Levetiracetam Injection 5ml",
    "generic": "Levetiracetam Injection 5ml",
    "strength": "5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Domestic pack",
    "desc": "Levetiracetam Injection 5ml (Domestic).",
    "composition": [
      "Each ml contains",
      "Levetiracetam - 100mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0378",
    "name": "Adrenaline Bi Tartrate Injection IP 1ml",
    "generic": "Adrenaline Bi Tartrate Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Adrenaline Bi Tartrate Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Adrenaline Bi Tartrate IP - .1.8mg",
      "Eq. to Adrenaline - 1.0mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0379",
    "name": "Methylcobalamin Injection 1ml",
    "generic": "Methylcobalamin Injection 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin Injection 1ml (Domestic).",
    "composition": [
      "Each ml contains",
      "Methylcobalamin IP - . 500mcg",
      "Benzyl Alcohol IP - . 2% v/v",
      "(As per preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0380",
    "name": "Methylcobalamin Injection 1ml",
    "generic": "Methylcobalamin Injection 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin Injection 1ml (Domestic).",
    "composition": [
      "Each ml contains",
      "Methylcobalamin IP - 2500mcg",
      "Benzyl Alcohol IP - 2% v/v",
      "(As per preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0381",
    "name": "Ivermectin Injection IP (for Vet.)",
    "generic": "Ivermectin Injection IP (for Vet.)",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Ivermectin Injection IP (for Vet.) (Domestic).",
    "composition": [
      "Each ml. contains:",
      "Ivermectin IP - 10 mg",
      "Benzyl Alcohol IP - 3 % v/v",
      "(As preservative)",
      "Propylene Glycol IP - q.s."
    ]
  },
  {
    "id": "p0382",
    "name": "Meloxicam Injection (for Vet.)",
    "generic": "Meloxicam Injection (for Vet.)",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Meloxicam Injection (for Vet.) (Domestic).",
    "composition": [
      "Each ml. contains:",
      "Meloxicam IP - 5 mg",
      "Benzyl Alcohol IP - 2 %v/v",
      "(As preservative)",
      "Propylene Glycol IP - . q.s."
    ]
  },
  {
    "id": "p0383",
    "name": "Prednisolone Acetate Injectable Suspension USP \"for Veterinary Use\" (10 Ml Vial)",
    "generic": "Prednisolone Acetate Injectable Suspension USP \"for Veterinary Use\" (10 Ml Vial)",
    "strength": "10 ML VIAL)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Prednisolone Acetate Injectable Suspension USP \"for Veterinary Use\" (10 Ml Vial) (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Prednisolone Acetate IP - 10 mg",
      "Benzyl Alcohol IP - . 0.945 % w/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0384",
    "name": "Prednisolone Sodium Phosphate Injection IP",
    "generic": "Prednisolone Sodium Phosphate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Prednisolone Sodium Phosphate Injection IP (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Prednisolone Sodium Phosphate IP - 20 mg",
      "Benzyl Alcohol IP - .0.945 % w/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0385",
    "name": "Heparin Sodium Injection IP (5 Ml Vial)",
    "generic": "Heparin Sodium Injection IP (5 Ml Vial)",
    "strength": "5 ML VIAL)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Heparin Sodium Injection IP (5 Ml Vial) (Domestic).",
    "composition": [
      "Each ml contains:",
      "Heparin Sodium",
      "(from mucosa) IP - 5000 IU",
      "Benzyl Alcohol IP - 0.95 % v/v",
      "(As preservative)",
      "Water for Injection IP - . - q.s."
    ]
  },
  {
    "id": "p0386",
    "name": "Tranexamic Acid Injection IP (5 Ml. Amp.)",
    "generic": "Tranexamic Acid Injection IP (5 Ml. Amp.)",
    "strength": "5 ML. AMP.)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Tranexamic Acid Injection IP (5 Ml. Amp.) (Domestic).",
    "composition": [
      "Each ml. contains:",
      "Tranexamic acid IP - . 100mg",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0387",
    "name": "Nandrolone Decanoate Injection IP (1 Ml Amp.)",
    "generic": "Nandrolone Decanoate Injection IP (1 Ml Amp.)",
    "strength": "1 ML AMP.)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "Domestic pack",
    "desc": "Nandrolone Decanoate Injection IP (1 Ml Amp.) (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Nandrolone Decanoate IP - . 50 mg",
      "Ethyl Oleate IP - . q.s."
    ]
  },
  {
    "id": "p0388",
    "name": "Nandrolone Decanoate Injection IP (1 Ml Amp.)",
    "generic": "Nandrolone Decanoate Injection IP (1 Ml Amp.)",
    "strength": "1 ML AMP.)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "Domestic pack",
    "desc": "Nandrolone Decanoate Injection IP (1 Ml Amp.) (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Nandrolone Decanoate IP - .25 mg",
      "Ethyl Oleate IP - q.s."
    ]
  },
  {
    "id": "p0389",
    "name": "Fluphenazine Decanoate Injection IP (1 Ml Amp.)",
    "generic": "Fluphenazine Decanoate Injection IP (1 Ml Amp.)",
    "strength": "1 ML AMP.)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Fluphenazine Decanoate Injection IP (1 Ml Amp.) (Domestic).",
    "composition": [
      "Each ml contains:",
      "Fluphenazine Decanoate IP - .25 mg",
      "Oil base - q.s."
    ]
  },
  {
    "id": "p0390",
    "name": "Enrofloxacin Injection (for Vet.) (multi Dose Vial Of 100 Ml)",
    "generic": "Enrofloxacin Injection (for Vet.) (multi Dose Vial Of 100 Ml)",
    "strength": "100 ML)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Enrofloxacin Injection (for Vet.) (multi Dose Vial Of 100 Ml) (Domestic).",
    "composition": [
      "Each ml. contains:",
      "Enrofloxacin IP - . 100 mg",
      "Benzyl Alcohol IP - 1.5 % v/v",
      "(As preservative)",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0391",
    "name": "Haloperidol Injection IP (1 Ml Ampoule)",
    "generic": "Haloperidol Injection IP (1 Ml Ampoule)",
    "strength": "1 ML AMPOULE)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Haloperidol Injection IP (1 Ml Ampoule) (Domestic).",
    "composition": [
      "Each ml contains:",
      "Haloperidol IP - 5mg",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0392",
    "name": "Haloperidol Injection IP (1 Ml Ampoule)",
    "generic": "Haloperidol Injection IP (1 Ml Ampoule)",
    "strength": "1 ML AMPOULE)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Haloperidol Injection IP (1 Ml Ampoule) (Domestic).",
    "composition": [
      "Each ml contains:",
      "Haloperidol IP - 10mg",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0393",
    "name": "Haloperidol Decanoate Injection (1 Ml Ampoule)",
    "generic": "Haloperidol Decanoate Injection (1 Ml Ampoule)",
    "strength": "1 ML AMPOULE)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Haloperidol Decanoate Injection (1 Ml Ampoule) (Domestic).",
    "composition": [
      "Each ml contains:",
      "Haloperidol Deaconate BP",
      "Eq. to Haloperidol - 50 mg",
      "Benzyl Alcohol IP - .1.5% v/v",
      "(as preservative)",
      "Oil base"
    ]
  },
  {
    "id": "p0394",
    "name": "Multivitamin Injection (2 Ml. Amp.)",
    "generic": "Multivitamin Injection (2 Ml. Amp.)",
    "strength": "2 ML. AMP.)",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Multivitamin Injection (2 Ml. Amp.) (Domestic).",
    "composition": [
      "Each 2 ml. contains:",
      "Thiamine Hydrochloride IP - .10 mg",
      "Pyridoxine Hydrochloride IP - .3 mg",
      "Niacinamide IP - .48 mg",
      "D-Panthenol IP - .50 mg",
      "Folic acid IP - .10mg",
      "Methylcobalamin - 1500 mcg",
      "Benzyl Alcohol IP - 1.5 % v/v",
      "(As Preservative)",
      "Water for Injection IP - q.s"
    ]
  },
  {
    "id": "p0395",
    "name": "Lorazepam Injection IP",
    "generic": "Lorazepam Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Lorazepam Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Lorazepam IP - .2 mg",
      "Benzyl alcohol IP - 2% v/v",
      "(as preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0396",
    "name": "Lorazepam Injection IP",
    "generic": "Lorazepam Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Lorazepam Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Lorazepam IP - 4 mg",
      "Benzyl alcohol IP - .2% v/v",
      "(as preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0397",
    "name": "Piracetam Injection",
    "generic": "Piracetam Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Domestic pack",
    "desc": "Piracetam Injection (Domestic).",
    "composition": [
      "Each ml contains:",
      "Piracetam IP - .200 mg",
      "Water for Injection - . q.s."
    ]
  },
  {
    "id": "p0398",
    "name": "Multivitamin Injection (For Vet. Use)",
    "generic": "Multivitamin Injection (For Vet. Use)",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Multivitamin Injection (For Vet. Use) (Domestic).",
    "composition": [
      "Each ml Contains: Thiamine HCl (Vit B1) IP - .10 mg",
      "Riboflavin Sodium Phosphate (B2) IP - 4 mg Niacinamide IP - .40mg Pyridoxine Hydrochloride (Vit. B6) IP - .4mg D Panthenol IP - .6mg",
      "Cyanocobalamin (Vit. B12) IP - 8mcg",
      "(cyanocobalamin) Benzyl Alcohol IP - 2 % v/v",
      "(As Preservative)",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0399",
    "name": "Dopamine Hydrochloride Injection IP",
    "generic": "Dopamine Hydrochloride Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dopamine Hydrochloride Injection IP (Domestic).",
    "composition": [
      "Each ml contains Dopamine Hydrochloride IP - 40mg",
      "Sodium Metabisulphite IP - .9.0mg",
      "(As Stabilizer)",
      "Water for Injection IP - .q.s."
    ]
  },
  {
    "id": "p0400",
    "name": "Lignocaine Injection IP 2%",
    "generic": "Lignocaine Injection IP 2%",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Lignocaine Injection IP 2% (Domestic).",
    "composition": [
      "Each ml contains Lignocaine Hydrochloride IP - .21.3mg",
      "Eq. to Lignocaine - .20.0 mg",
      "Sodium chloride IP - .6.0 mg",
      "Methyl paraben IP - 1.0mg (As preservative) Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0401",
    "name": "Mephentermine Sulphate Injection IP",
    "generic": "Mephentermine Sulphate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Mephentermine Sulphate Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Mephentermine Sulphate IP",
      "Eq. to Mephentermine - 30 mg",
      "Methyl Paraben IP - .0.18%w/v",
      "Propyl Paraben IP - . 0.02%w/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0402",
    "name": "Flupentixol Decanoate Injection IP",
    "generic": "Flupentixol Decanoate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "Domestic pack",
    "desc": "Flupentixol Decanoate Injection IP (Domestic).",
    "composition": [
      "Each ml contains: Flupentixol Decanoate IP - 20 mg",
      "Vegetable Oil base - q.s."
    ]
  },
  {
    "id": "p0403",
    "name": "Hydralazine Hydrochloride Injection IP",
    "generic": "Hydralazine Hydrochloride Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Hydralazine Hydrochloride Injection IP (Domestic).",
    "composition": [
      "Each ml contains",
      "Hydralazine HCl IP - 20 mg Preservatives:",
      "Methyl paraben IP - 0.65 mg",
      "(As preservative)",
      "Propyl paraben IP - .0.35 mg",
      "(As preservative)",
      "Water for Injections IP - .q.s."
    ]
  },
  {
    "id": "p0404",
    "name": "Methylprednisolone Injection IP",
    "generic": "Methylprednisolone Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Methylprednisolone Injection IP (Domestic).",
    "composition": [
      "Each ml contains",
      "Methylprednisolone Acetate IP - 40 mg",
      "Benzyl Alcohol IP - .8.88 mg",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0405",
    "name": "Bupivacaine Hcl In Dextrose Injection IP",
    "generic": "Bupivacaine Hcl In Dextrose Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Bupivacaine Hcl In Dextrose Injection IP (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Bupivacaine Hydrochloride IP - 5mg",
      "Equivalent to Anhydrous Bupivacaine Hydrochloride",
      "Dextrose IP - 80mg",
      "(As Monohydrate) Water for Injections IP - .q.s."
    ]
  },
  {
    "id": "p0406",
    "name": "Bupivacaine Hcl In Dextrose Injection USP",
    "generic": "Bupivacaine Hcl In Dextrose Injection USP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Bupivacaine Hcl In Dextrose Injection USP (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Bupivacaine Hydrochloride USP - 7.5mg",
      "Equivalent to Anhydrous Bupivacaine Hydrochloride",
      "Dextrose USP - .82.5mg",
      "(As Monohydrate) Water for Injections IP - .q.s."
    ]
  },
  {
    "id": "p0407",
    "name": "Bupivacaine Hydrochloride Injection IP",
    "generic": "Bupivacaine Hydrochloride Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Bupivacaine Hydrochloride Injection IP (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Bupivacaine Hydrochloride IP - .0.25% w/v Equivalent to Anhydrous Bupivacaine Hydrochloride",
      "Sodium Chloride IP - 8.0 mg",
      "Methyl Paraben IP - 1.0 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0408",
    "name": "Bupivacaine Hydrochloride Injection IP",
    "generic": "Bupivacaine Hydrochloride Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Bupivacaine Hydrochloride Injection IP (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Bupivacaine Hydrochloride IP - .0.5% w/v Equivalent to Anhydrous Bupivacaine Hydrochloride",
      "Sodium Chloride IP - .8.0 mg",
      "Methyl Paraben IP - 1.0 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0409",
    "name": "Bupivacaine Hydrochloride Injection IP",
    "generic": "Bupivacaine Hydrochloride Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Bupivacaine Hydrochloride Injection IP (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Bupivacaine Hydrochloride IP - 0.75% w/v Equivalent to Anhydrous Bupivacaine Hydrochloride",
      "Sodium Chloride IP - .8.0 mg",
      "Methyl Paraben IP - 1.0 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0410",
    "name": "Esomeprazole Sodium For Injection",
    "generic": "Esomeprazole Sodium For Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Esomeprazole Sodium For Injection (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Esomeprazole Sodium",
      "Eq. to Esomeprazole - 40 mg"
    ]
  },
  {
    "id": "p0411",
    "name": "Omeprazole For Injection",
    "generic": "Omeprazole For Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Omeprazole For Injection (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "(Omeprazole IP 40 mg)",
      "Omeparzole Sodium",
      "Eq. to Omeprazole - 40 mg"
    ]
  },
  {
    "id": "p0412",
    "name": "Pantoprazole Sodium For Injection",
    "generic": "Pantoprazole Sodium For Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Pantoprazole Sodium For Injection (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Pantoprazole Sodium IP (sterile)",
      "(Lyophilized)",
      "Eq. to Pantoprazole - 40 mg"
    ]
  },
  {
    "id": "p0413",
    "name": "Aciclovir Intravenous Infusion IP",
    "generic": "Aciclovir Intravenous Infusion IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Aciclovir Intravenous Infusion IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Aciclovir Sodium IP",
      "Eq. to Aciclovir - .250mg"
    ]
  },
  {
    "id": "p0414",
    "name": "Aciclovir Intravenous Infusion IP",
    "generic": "Aciclovir Intravenous Infusion IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Aciclovir Intravenous Infusion IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Aciclovir Sodium IP",
      "Eq. to Aciclovir - 500mg"
    ]
  },
  {
    "id": "p0415",
    "name": "Hydrocortisone Sodium Succinate Injection IP",
    "generic": "Hydrocortisone Sodium Succinate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Hydrocortisone Sodium Succinate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Hydrocortisone Sodium Succinate IP",
      "Eq. to Hydrocortisone - .100mg"
    ]
  },
  {
    "id": "p0416",
    "name": "Artesunate Injection IP",
    "generic": "Artesunate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Artesunate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Artesunate IP - .60 mg"
    ]
  },
  {
    "id": "p0417",
    "name": "Artesunate Injection IP",
    "generic": "Artesunate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Artesunate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Artesunate IP - 120 mg"
    ]
  },
  {
    "id": "p0418",
    "name": "Artesunate Injection IP",
    "generic": "Artesunate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Artesunate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Artesunate IP - 60 mg"
    ]
  },
  {
    "id": "p0419",
    "name": "Sodium Bicarbonate Injection IP",
    "generic": "Sodium Bicarbonate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Sodium Bicarbonate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sodium bicarbonate IP - .5.0 % w/v",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0420",
    "name": "Sodium Bicarbonate Injection IP",
    "generic": "Sodium Bicarbonate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Sodium Bicarbonate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sodium bicarbonate IP - 7.5 % w/v",
      "Water for Injection IP - . q.s."
    ]
  },
  {
    "id": "p0421",
    "name": "Sodium Bicarbonate Injection",
    "generic": "Sodium Bicarbonate Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Sodium Bicarbonate Injection (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sodium bicarbonate IP - .8.4 % w/v",
      "Water for Injection IP - . - q.s."
    ]
  },
  {
    "id": "p0422",
    "name": "Lignocaine Hydrochloride And Adrenaline Injection IP",
    "generic": "Lignocaine Hydrochloride And Adrenaline Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Lignocaine Hydrochloride And Adrenaline Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Adrenaline Bi Tartrate IP - 0.009 mg",
      "e.q to Adrenaline - 0.005 mg",
      "Lignocaine Hydrochloride IP - .21.33 mg",
      "Sodium Chloride IP - .6.0 mg",
      "Sodium Metabisulphite IP - .0.50 mg",
      "Methyl Paraben IP - .1.0 mg",
      "(As preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0423",
    "name": "Fentanyl Injection IP",
    "generic": "Fentanyl Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Fentanyl Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Fentanyl Citrate IP",
      "Eq. to. Fentanyl - 50mcg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0424",
    "name": "Atropine Injection BP",
    "generic": "Atropine Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Atropine Injection BP (Export).",
    "composition": [
      "Each ml contains:",
      "Atropine Sulphate BP - .0.5 mg",
      "Water for Injections BP - . q.s."
    ]
  },
  {
    "id": "p0425",
    "name": "Enoxaparin Injection IP",
    "generic": "Enoxaparin Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Enoxaparin Injection IP (Domestic).",
    "composition": [
      "Enoxaparin Sodium IP - .40 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0426",
    "name": "Carboxymethyl Cellulose Eye Drops IP",
    "generic": "Carboxymethyl Cellulose Eye Drops IP",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "Domestic pack",
    "desc": "Carboxymethyl Cellulose Eye Drops IP (Domestic).",
    "composition": [
      "Carboxy Methyl Cellulose Sodium IP - 1.0% w/v",
      "Stabilized Oxychloro complex IP - 0.005%w/v",
      "(As preservative)",
      "Sterile Aqueous Vehicle - . q.s."
    ]
  },
  {
    "id": "p0427",
    "name": "Sodium Chloride Eye Or Nasal Drops IP",
    "generic": "Sodium Chloride Eye Or Nasal Drops IP",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "Domestic pack",
    "desc": "Sodium Chloride Eye Or Nasal Drops IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Sodium Chloride IP - .0.9% w/v",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0428",
    "name": "Clindamycin Injection IP",
    "generic": "Clindamycin Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Clindamycin Injection IP (Domestic).",
    "composition": [
      "Each 4 ml contains:",
      "Clindamycin Phosphate IP",
      "Eq. to Clindamycin - 600mg",
      "Benzyl Alcohol - .0.9%v/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0429",
    "name": "Lignocaine Injection IP",
    "generic": "Lignocaine Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Lignocaine Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Lignocaine Hydrochloride IP - 21.3mg",
      "Sodium Chloride IP - .6.0mg",
      "Methyl Paraben IP - .1.0mg",
      "(As preservative)",
      "Water for Injections IP - . - q.s."
    ]
  },
  {
    "id": "p0430",
    "name": "Lincomycin Injection USP 2ml Ampoule",
    "generic": "Lincomycin Injection USP 2ml Ampoule",
    "strength": "2ML AMPOULE",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Lincomycin Injection USP 2ml Ampoule (Domestic).",
    "composition": [
      "Each ml contains:",
      "Lincomycin Hydrochloride IP",
      "Eq. to Lincomycin - .300mg",
      "Benzyl Alcohol IP - 0.9% v/v",
      "(As preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0431",
    "name": "Tigecycline Injection USP 50mg",
    "generic": "Tigecycline Injection USP 50mg",
    "strength": "50MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Tigecycline Injection USP 50mg (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Tigecycline USP - .50MG"
    ]
  },
  {
    "id": "p0432",
    "name": "Vancomycin For Injection USP 1000mg",
    "generic": "Vancomycin For Injection USP 1000mg",
    "strength": "1000MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Vancomycin For Injection USP 1000mg (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Vancomycin Hydrochloride IP",
      "Eq. to Vancomycin - 1000mg"
    ]
  },
  {
    "id": "p0433",
    "name": "Rabeprazole Injection IP",
    "generic": "Rabeprazole Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Rabeprazole Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Rabeprazole Sodium IP",
      "Eq. to Rabeprazole - .20mg"
    ]
  },
  {
    "id": "p0434",
    "name": "Lignocaine Injection IP",
    "generic": "Lignocaine Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Lignocaine Injection IP (Domestic).",
    "composition": [
      "Each ml contains Lignocaine Hydrochloride IP",
      "Eq. to Lignocaine - 10.0 mg",
      "Sodium chloride IP - .6.0 mg",
      "Methyl paraben IP - 1.0mg",
      "(As preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0435",
    "name": "Frusemide Injection I.p.",
    "generic": "Frusemide Injection I.p.",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Frusemide Injection I.p. (Domestic).",
    "composition": [
      "Each ml contains",
      "Frusemide IP - 10 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0436",
    "name": "Gentamycin Injection IP",
    "generic": "Gentamycin Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamycin Injection IP (Domestic).",
    "composition": [
      "Each ml contains",
      "Gentamicin Sulphate IP",
      "e.q. to Gentamicin - 10 mg",
      "Methyl Paraben IP - 0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0437",
    "name": "Lignocaine Hydrochloride And Adrenaline Injection IP",
    "generic": "Lignocaine Hydrochloride And Adrenaline Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Lignocaine Hydrochloride And Adrenaline Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Adrenaline Bi Tartrate IP 0.009 mg",
      "e.q to Adrenaline - .0.005 mg",
      "Lignocaine Hydrochloride IP - .21.33 mg",
      "Sodium Chloride IP - . - .6.0 mg",
      "Sodium Metabisulphite IP - .0.50 mg",
      "Methyl Paraben IP - .1.0 mg",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0438",
    "name": "Atropine Sulphate Injection IP",
    "generic": "Atropine Sulphate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Atropine Sulphate Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Atropine Sulphate IP - .0.6 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0439",
    "name": "Oxytetracycline Injection IP",
    "generic": "Oxytetracycline Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Oxytetracycline Injection IP (Domestic).",
    "composition": [
      "Each ml contains",
      "Oxytetracycline IP",
      "Eq. to Anhydrous Oxytetracycline - .50mg",
      "Lignocaine IP - .2%w/v",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0440",
    "name": "Methylcobalamin, Pyridoxine Hydrochloride & Nicotinamide Injection",
    "generic": "Methylcobalamin",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin, Pyridoxine Hydrochloride & Nicotinamide Injection (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Methylcobalamin IP - .2500 mcg",
      "Pyridoxine Hydrochloride IP - .100 mg",
      "Nicotinamide IP - 100 mg",
      "Benzyl Alcohol IP - 2% v/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0441",
    "name": "Methylcobalamin, Pyridoxine Hydrochloride & Nicotinamide Injection",
    "generic": "Methylcobalamin",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin, Pyridoxine Hydrochloride & Nicotinamide Injection (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Methylcobalamin IP - 1500 mcg",
      "Pyridoxine Hydrochloride IP - .100 mg",
      "Nicotinamide IP - 100 mg",
      "Benzyl Alcohol IP - .2% v/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0442",
    "name": "Ondansetron Injection IP 10ml",
    "generic": "Ondansetron Injection IP 10ml",
    "strength": "10ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Ondansetron Injection IP 10ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ondansetron hydrochloride IP",
      "Eq. to Ondansetron - .2 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0443",
    "name": "Ondansetron Injection IP 4ml",
    "generic": "Ondansetron Injection IP 4ml",
    "strength": "4ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Ondansetron Injection IP 4ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ondansetron hydrochloride IP",
      "Eq. to Ondansetron - .2 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0444",
    "name": "Methylergometrine Injection",
    "generic": "Methylergometrine Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Methylergometrine Injection (Domestic).",
    "composition": [
      "Each ml contains",
      "Methyl Ergometrine Maleate IP - 0.2 mg"
    ]
  },
  {
    "id": "p0445",
    "name": "Metoclopramide Injection IP 10 Ml",
    "generic": "Metoclopramide Injection IP 10 Ml",
    "strength": "10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Metoclopramide Injection IP 10 Ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Metoclopramide Hydrochloride IP",
      "Eq. to Metoclopramide HCl - 5 mg",
      "(Anhydrous)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0446",
    "name": "Triamcinolone Acetonide Injection IP 1ml",
    "generic": "Triamcinolone Acetonide Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "Domestic pack",
    "desc": "Triamcinolone Acetonide Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Triamcinolone Acetonide IP - .40 mg",
      "Benzyl Alcohol IP - .0.9% v/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0447",
    "name": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxine Hydrochloride, Niacinamide& D-panthenol Injection",
    "generic": "Methylcobalamin",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxine Hydrochloride, Niacinamide& D-panthenol Injection (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Methylcobalamin IP - .1000 mcg",
      "Thiamine Hydrochloride IP - .100 mg",
      "Pyridoxin Hydrochloride IP - .100 mg",
      "Niacinamide IP - 100 mg",
      "D-Panthenol IP - 50 mg",
      "Benzyl Alcohol IP - 2% v/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0448",
    "name": "Thiamine Hydrochloride, Riboflavin, Sodium Phosphate, Pyridoxine Hydrochloride, Nicotinamide, Cynocobalamin & D-panthenol Injection",
    "generic": "Thiamine Hydrochloride",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Thiamine Hydrochloride, Riboflavin, Sodium Phosphate, Pyridoxine Hydrochloride, Nicotinamide, Cynocobalamin & D-panthenol Injection (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Thiamine Hydrochloride IP - .10 mg",
      "Riboflavin Sodium Phosphate IP - .4 mg",
      "Pyridoxine Hydrochloride IP - 4 mg",
      "Nicotinamide IP - 40 mg",
      "Cyanocobalamin IP - 8 mg",
      "D-Panthenol IP - 6 mg",
      "Benzyl Alcohol IP - .0.9% v/v",
      "(As preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0449",
    "name": "Pantoprazole Sodium For Injection BP",
    "generic": "Pantoprazole Sodium For Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Pantoprazole Sodium For Injection BP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Pantoprazole Sodium IP (sterile)",
      "(Lyophilized)",
      "Eq. to Pantoprazole - 40 mg"
    ]
  },
  {
    "id": "p0450",
    "name": "Injection Of Etofylline And Theophylline 2 Ml",
    "generic": "Injection Of Etofylline And Theophylline 2 Ml",
    "strength": "2 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Injection Of Etofylline And Theophylline 2 Ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Etofylline BP - .84.7 mg",
      "Theophylline IP",
      "(Anhydrous)",
      "Eq. to Theophylline IP - .25.3 mg",
      "(Hydrate)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0451",
    "name": "Mecobalamin Injection",
    "generic": "Mecobalamin Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Mecobalamin Injection (Domestic).",
    "composition": [
      "Each 2 ml contains:",
      "Mecobalamin IP - .1500 mcg",
      "Benzyl Alcohol IP - .2% v/v",
      "(As per preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0452",
    "name": "Sterile Noradrenaline Concentrate IP",
    "generic": "Sterile Noradrenaline Concentrate IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Sterile Noradrenaline Concentrate IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Noradrenaline Bitartrate IP",
      "Eq. to Noradrenaline 1.0mg - 2 mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0453",
    "name": "Nandrolone Decanoate Injection Ip- 100mg",
    "generic": "Nandrolone Decanoate Injection Ip- 100mg",
    "strength": "100MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "Domestic pack",
    "desc": "Nandrolone Decanoate Injection Ip- 100mg (Domestic).",
    "composition": [
      "Each ml Contains:",
      "Nandrolone Decanoate IP - 100 mg",
      "Ethyl Oleate IP - . q.s.",
      "(As Oily base)"
    ]
  },
  {
    "id": "p0454",
    "name": "Diclofenac Injection IP Not For Veterinary Use",
    "generic": "Diclofenac Injection IP Not For Veterinary Use",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Diclofenac Injection IP Not For Veterinary Use (Domestic).",
    "composition": [
      "Each ml contains:",
      "Diclofenac Sodium IP - .75mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0455",
    "name": "Ranitidine Injection USP",
    "generic": "Ranitidine Injection USP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Export pack",
    "desc": "Ranitidine Injection USP (Export).",
    "composition": [
      "Each 2 ml contains:",
      "Ranitidine hydrochloride USP",
      "e.q to Ranitidine - 50mg",
      "Phenol USP - 0.5 % w/v",
      "(As preservative)",
      "Water for Injections USP - . q.s."
    ]
  },
  {
    "id": "p0456",
    "name": "Adrenaline Bi Tartrate Injection BP",
    "generic": "Adrenaline Bi Tartrate Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Adrenaline Bi Tartrate Injection BP (Export).",
    "composition": [
      "Each ml contains:",
      "Adrenaline Bi Tartrate BP 1.8mg",
      "e.q to Adrenaline - 1.0mg",
      "Water for Injections BP - . q.s."
    ]
  },
  {
    "id": "p0457",
    "name": "Methylcobalamin, Pyridoxine Hydrochloride, Niacinamide And D-panthenol Injection",
    "generic": "Methylcobalamin",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin, Pyridoxine Hydrochloride, Niacinamide And D-panthenol Injection (Domestic).",
    "composition": [
      "Each 2 ml contains",
      "Methylcobalamin IP - .1500 mcg",
      "Niacinamide IP - .100 mg",
      "Pyridoxine Hydrochloride IP - 100 mg",
      "D-Panthenol IP - .50mg",
      "Benzyl Alcohol IP - 2%v/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0458",
    "name": "Moxifloxacin Hydrochloride And Ketorolac Ophthalmic Solution",
    "generic": "Moxifloxacin Hydrochloride And Ketorolac Ophthalmic Solution",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Moxifloxacin Hydrochloride And Ketorolac Ophthalmic Solution (Domestic).",
    "composition": [
      "Composition",
      "Moxifloxacin Hydrochloride IP",
      "Eq. to Moxifloxacin - .0.5%w/v",
      "Ketorolac Tromethamine IP - 0.5%w/v",
      "Isotonic Aqueous Vehicle - . q.s."
    ]
  },
  {
    "id": "p0459",
    "name": "Dexamethasone Injection IP",
    "generic": "Dexamethasone Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dexamethasone Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dexamethasone Sodium phosphate IP",
      "e.q. to Dexamethasone phosphate - .4.0mg",
      "Methyl Paraben IP - .0.15%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water or Injections IP - q.s."
    ]
  },
  {
    "id": "p0460",
    "name": "Hydroxocobalamin Injection IP 1ml",
    "generic": "Hydroxocobalamin Injection IP 1ml",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Hydroxocobalamin Injection IP 1ml (Domestic).",
    "composition": [
      "Each ml contains.",
      "Hydroxocobalamin IP",
      "(Anhydrous) - .1000mcg",
      "Glacial Acetic Acid - q.s.",
      "(For PH adjustment to about 4)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0461",
    "name": "Hydroxocobalamin Injection IP 5ml",
    "generic": "Hydroxocobalamin Injection IP 5ml",
    "strength": "5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Hydroxocobalamin Injection IP 5ml (Domestic).",
    "composition": [
      "Each ml contains.",
      "Hydroxocobalamin IP",
      "(Anhydrous) - .1000mcg",
      "Methylparaben IP - .0.1 % w/v",
      "(as preservative)",
      "Propyl paraben IP - .0.02 % w/v",
      "(as preservative)",
      "Glacial Acetic acid - q.s. (For PH adjustment to about 4)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0462",
    "name": "Gentamicin Injection IP",
    "generic": "Gentamicin Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamicin Injection IP (Domestic).",
    "composition": [
      "Each ml contains",
      "Gentamicin Sulphate IP",
      "e.q. to Gentamicin - 40mg",
      "Methyl Paraben IP - 0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0463",
    "name": "Gentamycin Sulphate Injection IP 2ml Vial",
    "generic": "Gentamycin Sulphate Injection IP 2ml Vial",
    "strength": "2ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamycin Sulphate Injection IP 2ml Vial (Domestic).",
    "composition": [
      "Each 2ml contains",
      "Gentamicin Sulphate IP",
      "e.q. to Gentamicin base - 80mg",
      "Methyl Paraben IP - 0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0464",
    "name": "Gentamycin Sulphate Injection IP 10ml Vial",
    "generic": "Gentamycin Sulphate Injection IP 10ml Vial",
    "strength": "10ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamycin Sulphate Injection IP 10ml Vial (Domestic).",
    "composition": [
      "Each 2ml contains",
      "Gentamicin Sulphate IP",
      "e.q. to Gentamicin base - .80mg",
      "Methyl Paraben IP - .0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0465",
    "name": "Gentamycin Sulphate Injection IP 20ml Vial",
    "generic": "Gentamycin Sulphate Injection IP 20ml Vial",
    "strength": "20ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamycin Sulphate Injection IP 20ml Vial (Domestic).",
    "composition": [
      "Each 2ml contains",
      "Gentamicin Sulphate IP",
      "e.q. to Gentamicin base - .80mg",
      "Methyl Paraben IP - .0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0466",
    "name": "Gentamycin Sulphate Injection IP 30ml Vial",
    "generic": "Gentamycin Sulphate Injection IP 30ml Vial",
    "strength": "30ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Gentamycin Sulphate Injection IP 30ml Vial (Domestic).",
    "composition": [
      "Each 2ml contains",
      "Gentamicin Sulphate IP",
      "e.q. to Gentamicin base - .80mg",
      "Methyl Paraben IP - .0.18%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0467",
    "name": "Dexamethasone Sodium Phosphate Injection IP 2ml Vial",
    "generic": "Dexamethasone Sodium Phosphate Injection IP 2ml Vial",
    "strength": "2ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dexamethasone Sodium Phosphate Injection IP 2ml Vial (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dexamethasone sodium phosphate IP",
      "e.q. to Dexamethasone phosphate - 4.0mg",
      "Methyl Paraben IP - .0.15%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0468",
    "name": "Dexamethasone Sodium Phosphate Injection IP 10ml Vial",
    "generic": "Dexamethasone Sodium Phosphate Injection IP 10ml Vial",
    "strength": "10ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dexamethasone Sodium Phosphate Injection IP 10ml Vial (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dexamethasone sodium phosphate IP",
      "e.q. to Dexamethasone phosphate - 4.0mg",
      "Methyl Paraben IP - 0.15%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - . 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0469",
    "name": "Dexamethasone Sodium Phosphate Injection IP 20ml Vial",
    "generic": "Dexamethasone Sodium Phosphate Injection IP 20ml Vial",
    "strength": "20ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dexamethasone Sodium Phosphate Injection IP 20ml Vial (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dexamethasone sodium phosphate IP",
      "e.q. to Dexamethasone phosphate. - .4.0mg",
      "Methyl Paraben IP - 0.15%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0470",
    "name": "Dexamethasone Sodium Phosphate Injection IP 30ml Vial",
    "generic": "Dexamethasone Sodium Phosphate Injection IP 30ml Vial",
    "strength": "30ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Dexamethasone Sodium Phosphate Injection IP 30ml Vial (Domestic).",
    "composition": [
      "Each ml contains:",
      "Dexamethasone sodium phosphate IP",
      "e.q. to Dexamethasone phosphate - 4.0mg",
      "Methyl Paraben IP - .0.15%w/v",
      "(As Preservative)",
      "Propyl Paraben IP - .0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0471",
    "name": "Injection Of Vitamin B1, B6, B12 & D-panthenol 3ml Ampoule",
    "generic": "Injection Of Vitamin B1",
    "strength": "3ML AMPOULE",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Injection Of Vitamin B1, B6, B12 & D-panthenol 3ml Ampoule (Domestic).",
    "composition": [
      "Each ml contains:",
      "Thiamine Hydrochloride IP - 33mg",
      "Pyridoxine hydrochloride IP - .33mg",
      "Cyanocobalamin IP - 333mcg",
      "D-Panthenol IP - .5mg",
      "Benzyl Alcohol IP - .2% w/v",
      "(as preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0472",
    "name": "Torsemide Injection 10mg/ml 2ml Ampoule",
    "generic": "Torsemide Injection 10mg/ml 2ml Ampoule",
    "strength": "10MG/ML 2ML AMPOULE",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Torsemide Injection 10mg/ml 2ml Ampoule (Domestic).",
    "composition": [
      "Each ml contains:",
      "Torsemide IP - .10mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0473",
    "name": "Hydrocortisone Sodium Succinate Injection IP",
    "generic": "Hydrocortisone Sodium Succinate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Hydrocortisone Sodium Succinate Injection IP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Hydrocortisone Sodium Succinate USP",
      "Eq. to Hydrocortisone - 100mg"
    ]
  },
  {
    "id": "p0474",
    "name": "Hydrocortisone Sodium Succinate Injection BP",
    "generic": "Hydrocortisone Sodium Succinate Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Hydrocortisone Sodium Succinate Injection BP (Export).",
    "composition": [
      "Each Vial Contains:",
      "Sterile Hydrocortisone Sodium Succinate USP",
      "Eq. to Hydrocortisone - 500mg"
    ]
  },
  {
    "id": "p0475",
    "name": "Gentamicin + Dexamethasone Eye/ear Drops",
    "generic": "Gentamicin + Dexamethasone Eye/ear Drops",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Gentamicin + Dexamethasone Eye/ear Drops (Export).",
    "composition": [
      "Gentamicin Sulphate BP",
      "e.q. to Gentamicin - 3 mg",
      "Dexamethasone Sodium phosphate BP",
      "Eq. to Dexamethasone phosphate - 1 mg",
      "Benzalkonium Chloride Solution BP - 0.01%v/v",
      "(As preservative)",
      "Water for Injection - q.s."
    ]
  },
  {
    "id": "p0476",
    "name": "Gentamicin Eye/ear Drops BP",
    "generic": "Gentamicin Eye/ear Drops BP",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Gentamicin Eye/ear Drops BP (Export).",
    "composition": [
      "Composition:",
      "Gentamicin Sulphate BP",
      "e.q. to Gentamicin - 0.3%w/v",
      "Benzalkonium Chloride Solution BP - 0.02%v/v",
      "(As preservative)",
      "Water for Injection - . q.s."
    ]
  },
  {
    "id": "p0477",
    "name": "Multivitamin Injection",
    "generic": "Multivitamin Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Multivitamin Injection (Domestic).",
    "composition": [
      "Each ml contains:",
      "Vitamin A IP - 1000 I.U.",
      "(As Paimitate)",
      "Cholecalciferol IP - .100I.U.",
      "Alpha Tocopheryl Acetate IP - .0.50 mg",
      "Thiamine Hydrochloride IP - 5 mg",
      "Pyridoxine Hydrochloride IP - .1.50 mg",
      "Riboflavin Sodium Phosphate IP - .1.40 mg",
      "Ascorbic Acid IP - .50 mg",
      "Nicotinamide IP - .10 mg",
      "D-Panthenol IP - 2.50 mg",
      "Benzyl Alcohol IP - 1% w/v",
      "(As Preservative)",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0478",
    "name": "Amikacin Sulphate Injection IP",
    "generic": "Amikacin Sulphate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP (Domestic).",
    "composition": [
      "Each 2ml contains:",
      "Amikacin Sulphate IP",
      "e.q. to Amikacin - 500mg",
      "Methyl Paraben IP - 0.08%w/v",
      "(As Preservative)",
      "Propyl paraben IP - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s"
    ]
  },
  {
    "id": "p0479",
    "name": "Amikacin Sulphate Injection IP",
    "generic": "Amikacin Sulphate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Amikacin Sulphate IP",
      "e.q. to Amikacin - 250mg",
      "Sodium Methyl Paraben IP - 0.08%w/v",
      "(As Preservative)",
      "Sodium Propyl paraben IP - . - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0480",
    "name": "Carmellose Sodium 0.5% W/v Eye Drops",
    "generic": "Carmellose Sodium 0.5% W/v Eye Drops",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "Export pack",
    "desc": "Carmellose Sodium 0.5% W/v Eye Drops (Export).",
    "composition": [
      "Each ml contains:",
      "Carmelose Sodium BP - .5mg",
      "Stabilized oxychlorine complex - 0.05mg",
      "Sterile aqueous buffered vehicle - q.s."
    ]
  },
  {
    "id": "p0481",
    "name": "Diclofenac Sodium Injection IP",
    "generic": "Diclofenac Sodium Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "Domestic pack",
    "desc": "Diclofenac Sodium Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Diclofenac Sodium IP - 75mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0482",
    "name": "Ondansetron Injection IP",
    "generic": "Ondansetron Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Domestic pack",
    "desc": "Ondansetron Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Ondansetron hydrochloride IP",
      "(As Dihydrate)",
      "Eq. to ondansetron - 2mg",
      "Methyl Paraben IP - 0.18%w/v",
      "(As Preservative)",
      "Propyl paraben IP - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0483",
    "name": "Vitamin C Injection IP",
    "generic": "Vitamin C Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Vitamin C Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Vitamin C IP - 100mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0484",
    "name": "Sterile Potassium Chloride Concentrate Injection BP",
    "generic": "Sterile Potassium Chloride Concentrate Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Sterile Potassium Chloride Concentrate Injection BP (Export).",
    "composition": [
      "Each ml contains:",
      "Potassium Chloride IP - .150 mg",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0485",
    "name": "Hyoscine Butylbromide Injection BP",
    "generic": "Hyoscine Butylbromide Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Export pack",
    "desc": "Hyoscine Butylbromide Injection BP (Export).",
    "composition": [
      "Each ml contains:",
      "Hyoscine Butylbromide B.P - 20mg",
      "Water for Injections B.P - q.s."
    ]
  },
  {
    "id": "p0486",
    "name": "Heparin Injection BP 5000 IU/5ml",
    "generic": "Heparin Injection BP 5000 IU/5ml",
    "strength": "5000 IU/5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Domestic pack",
    "desc": "Heparin Injection BP 5000 IU/5ml (Domestic).",
    "composition": [
      "Each ml contains:",
      "Heparin Sodium BP - . - 1000 IU",
      "(Drived from mucosa)",
      "Benzyl Alcohol BP - 0.95% w/v",
      "Water for Injections BP - q.s."
    ]
  },
  {
    "id": "p0487",
    "name": "Chloramphenicol Eye Drops BP",
    "generic": "Chloramphenicol Eye Drops BP",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "Export pack",
    "desc": "Chloramphenicol Eye Drops BP (Export).",
    "composition": [
      "Chloramphenicol BP - . - 0.5 % w/v",
      "Phenylmercuric Nitrate BP - 0.001% w/v",
      "(As Preservative)",
      "Sterile Aqueous Base - q.s."
    ]
  },
  {
    "id": "p0488",
    "name": "Amikacin Sulphate Injection IP",
    "generic": "Amikacin Sulphate Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Amikacin Sulphate Injection IP (Domestic).",
    "composition": [
      "Each ml contains:",
      "Amikacin Sulphate IP",
      "E.q. to Amikacin - 100mg",
      "Sodium Methyl Paraben IP - 0.08%w/v",
      "(As Preservative)",
      "Sodium Propyl paraben IP - . - 0.02%w/v",
      "(As Preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0489",
    "name": "Methylcobalamin Injection",
    "generic": "Methylcobalamin Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Methylcobalamin Injection (Domestic).",
    "composition": [
      "Each ml contains",
      "Methylcobalamin IP - 1000 mcg",
      "Benzyl Alcohol IP - .2% v/v",
      "(As per preservative)",
      "Water for Injections IP - q.s."
    ]
  },
  {
    "id": "p0490",
    "name": "Amikacin Sulfate Injection USP 2ml",
    "generic": "Amikacin Sulfate Injection USP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Amikacin Sulfate Injection USP 2ml (Export).",
    "composition": [
      "Each 2ml contains:",
      "Amikacin Sulfate USP",
      "equivalent to Amikacin - . 500mg",
      "Water for Injections USP - q.s.",
      "Methylparaben USP - . - . - 0.08%w/v",
      "(As Preservative)",
      "Propylparaben USP - . - .0.02%w/v",
      "(As Preservative)"
    ]
  },
  {
    "id": "p0491",
    "name": "Amikacin Sulfate Injection USP 2ml",
    "generic": "Amikacin Sulfate Injection USP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Amikacin Sulfate Injection USP 2ml (Export).",
    "composition": [
      "Each 2ml contains:",
      "Amikacin Sulfate USP",
      "equivalent to Amikacin - . 250mg",
      "Water for Injections USP - q.s.",
      "Methylparaben USP - . - . - 0.08%w/v",
      "(As Preservative)",
      "Propylparaben USP - . - .0.02%w/v",
      "(As Preservative)"
    ]
  },
  {
    "id": "p0492",
    "name": "Amikacin Sulfate Injection USP 2ml",
    "generic": "Amikacin Sulfate Injection USP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Amikacin Sulfate Injection USP 2ml (Export).",
    "composition": [
      "Each 2ml contains:",
      "Amikacin Sulfate USP",
      "equivalent to Amikacin - . 100mg",
      "Water for Injections USP - q.s.",
      "Methylparaben USP - . - . - 0.08%w/v",
      "(As Preservative)",
      "Propylparaben USP - . - .0.02%w/v",
      "(As Preservative)"
    ]
  },
  {
    "id": "p0493",
    "name": "Heparin Injection BP 5 Ml Vial",
    "generic": "Heparin Injection BP 5 Ml Vial",
    "strength": "5 ML VIAL",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Heparin Injection BP 5 Ml Vial (Export).",
    "composition": [
      "Each ml contains:",
      "Heparin Sodium BP - 5000 IU",
      "Benzyl Alcohol BP - 0.95 % v/v",
      "(As preservative)",
      "Water for Injections BP - q.s."
    ]
  },
  {
    "id": "p0494",
    "name": "Multivitamin Injection 2 Ml Amp.",
    "generic": "Multivitamin Injection 2 Ml Amp.",
    "strength": "2 ML AMP.",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Export pack",
    "desc": "Multivitamin Injection 2 Ml Amp. (Export).",
    "composition": [
      "Each 2 ml. contains:",
      "Thiamine Hydrochloride USP - .10 mg",
      "Pyridoxine Hydrochloride USP - .3 mg",
      "Niacinamide USP - .48 mg",
      "D-Panthenol USP - .50 mg",
      "Folic acid USP - .10mg",
      "Methylcobalamin USP - 1500 mcg",
      "Benzyl Alcohol USP - 1.5 % v/v",
      "(As Preservative)",
      "Water for Injection USP - q.s"
    ]
  },
  {
    "id": "p0495",
    "name": "Piracetam Injection",
    "generic": "Piracetam Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Export pack",
    "desc": "Piracetam Injection (Export).",
    "composition": [
      "Each ml contains:",
      "Piracetam BP - 200 mg",
      "Water for Injections BP - q.s."
    ]
  },
  {
    "id": "p0496",
    "name": "Esomeprazole For Injection BP",
    "generic": "Esomeprazole For Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Export pack",
    "desc": "Esomeprazole For Injection BP (Export).",
    "composition": [
      "Each Vial Contains:",
      "Esomeprazole Sodium BP",
      "Eq. to Esomeprazole - 40 mg"
    ]
  },
  {
    "id": "p0497",
    "name": "Omeprazole For Injection BP",
    "generic": "Omeprazole For Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Export pack",
    "desc": "Omeprazole For Injection BP (Export).",
    "composition": [
      "Each Vial Contains:",
      "(Omeparzole BP 40 mg)",
      "Omeparzole Sodium BP",
      "Eq. to Omeprazole - 40 mg"
    ]
  },
  {
    "id": "p0498",
    "name": "Pantoprazole For Injection BP",
    "generic": "Pantoprazole For Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Export pack",
    "desc": "Pantoprazole For Injection BP (Export).",
    "composition": [
      "Each Vial Contains:",
      "Pantoprazole Sodium USP",
      "(Sterile Lyophilized)",
      "Eq. to Pantoprazole - 40 mg"
    ]
  },
  {
    "id": "p0499",
    "name": "Ondansetron Injection USP 10ml",
    "generic": "Ondansetron Injection USP 10ml",
    "strength": "10ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "Export pack",
    "desc": "Ondansetron Injection USP 10ml (Export).",
    "composition": [
      "Each ml contains:",
      "Ondansetron hydrochloride USP",
      "Eq. to Ondansetron USP - .2 mg",
      "Water for Injection USP - . q.s."
    ]
  },
  {
    "id": "p0500",
    "name": "Frusemide Injection USP 2ml",
    "generic": "Frusemide Injection USP 2ml",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Frusemide Injection USP 2ml (Export).",
    "composition": [
      "Each ml contains:",
      "Frusemide USP - 10 mg",
      "Water for Injection USP - . q.s."
    ]
  },
  {
    "id": "p0501",
    "name": "Citicoline Injection IP 4ml",
    "generic": "Citicoline Injection IP 4ml",
    "strength": "4ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Export pack",
    "desc": "Citicoline Injection IP 4ml (Export).",
    "composition": [
      "Each ml contains:",
      "Citicoline Sodium USP",
      "Eq. to Citicoline - .250 mg",
      "Methylparaben USP - 0.18%w/v",
      "(As preservative)",
      "Propylparaben USP - .0.02%w/v",
      "(As preservative)",
      "Water for Injection USP - . q.s."
    ]
  },
  {
    "id": "p0502",
    "name": "Levetiracetam Injection 5ml",
    "generic": "Levetiracetam Injection 5ml",
    "strength": "5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "Export pack",
    "desc": "Levetiracetam Injection 5ml (Export).",
    "composition": [
      "Each ml contains",
      "Levetiracetam USP - 100mg",
      "Water for Injection USP - . q.s."
    ]
  },
  {
    "id": "p0503",
    "name": "Carmellose Sodium Eye Drops BP 0.5% W/v",
    "generic": "Carmellose Sodium Eye Drops BP 0.5% W/v",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "Export pack",
    "desc": "Carmellose Sodium Eye Drops BP 0.5% W/v (Export).",
    "composition": [
      "Each ml contains:",
      "Carmellose Sodium B.P. - 5mg",
      "Stabilized oxychloro complex - 0.05mg",
      "Sterile aqueous buffered vehicle - q.s."
    ]
  },
  {
    "id": "p0504",
    "name": "Chloramphenicol BP Eye Drops",
    "generic": "Chloramphenicol BP Eye Drops",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "Export pack",
    "desc": "Chloramphenicol BP Eye Drops (Export).",
    "composition": [
      "Composition:",
      "Chloramphenicol BP - . - 0.5 % w/v",
      "Phenylmercuric Nitrate BP - .0.002% w/v",
      "(As Preservative)",
      "Sterile Isotonic Base - .q.s."
    ]
  },
  {
    "id": "p0505",
    "name": "Methylprednisolone Sodium Succinate For Injection USP",
    "generic": "Methylprednisolone Sodium Succinate For Injection USP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Methylprednisolone Sodium Succinate For Injection USP (Export).",
    "composition": [
      "Each Vial Contains:",
      "Methylprednisolone sodium Succinate USP",
      "Eq. to Methylprednisolone - 500mg"
    ]
  },
  {
    "id": "p0506",
    "name": "Methylprednisolone Sodium Succinate For Injection USP",
    "generic": "Methylprednisolone Sodium Succinate For Injection USP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Methylprednisolone Sodium Succinate For Injection USP (Export).",
    "composition": [
      "Each Vial Contains:",
      "Methylprednisolone sodium Succinate USP",
      "Eq. to Methylprednisolone - 1000mg"
    ]
  },
  {
    "id": "p0507",
    "name": "Dexamethasone Sodium Phosphate Injection USP 4mg",
    "generic": "Dexamethasone Sodium Phosphate Injection USP 4mg",
    "strength": "4MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Dexamethasone Sodium Phosphate Injection USP 4mg (Export).",
    "composition": [
      "Each ml Contains:",
      "Dexamethasone Sodium Phosphate USP",
      "equivalent to Dexamethasone Phosphate - 4mg"
    ]
  },
  {
    "id": "p0508",
    "name": "Ondansetron Injection IP",
    "generic": "Ondansetron Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron Injection IP ().",
    "composition": [
      "Each ml Contains:",
      "Ondansetron Hydrochloride IP",
      "Equivalent to Ondansetron - 2mg",
      "Water for Injections IP - . q.s."
    ]
  },
  {
    "id": "p0509",
    "name": "Omeprazole Sodium Injection",
    "generic": "Omeprazole Sodium Injection",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Omeprazole Sodium Injection ().",
    "composition": [
      "Each vial contains:",
      "Omeprazole sodium",
      "Eq. to Omeprazole - 40 mg"
    ]
  },
  {
    "id": "p0510",
    "name": "Doxycycline For Injection USP",
    "generic": "Doxycycline For Injection USP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Doxycycline For Injection USP (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Doxycycline Hydrochloride IP",
      "Eq. to Doxycycline - 100mg"
    ]
  },
  {
    "id": "p0511",
    "name": "Azithromycin For Injection USP",
    "generic": "Azithromycin For Injection USP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Azithromycin For Injection USP (Domestic).",
    "composition": [
      "Each vial contains:",
      "(Sterile) Azithromycin Dihydrate IP",
      "(Lyophilized) Eq. to Anhydrous",
      "Azithromycin - 500 mg"
    ]
  },
  {
    "id": "p0512",
    "name": "Artesunate Injection IP 60 Mg",
    "generic": "Artesunate Injection IP 60 Mg",
    "strength": "60 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Artesunate Injection IP 60 Mg (Domestic).",
    "composition": [
      "Each Vial Contains:",
      "Artesunate IP 60 mg",
      "(Sterile Lyophilized Powder)"
    ]
  },
  {
    "id": "p0513",
    "name": "Artesunate Injection 60 Mg",
    "generic": "Artesunate Injection 60 Mg",
    "strength": "60 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Artesunate Injection 60 Mg (Export).",
    "composition": [
      "Each Vial Contains:",
      "Artesunate 60 mg",
      "(Sterile Lyophilized Powder)"
    ]
  },
  {
    "id": "p0514",
    "name": "Artesunate Injection 120 Mg",
    "generic": "Artesunate Injection 120 Mg",
    "strength": "120 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Artesunate Injection 120 Mg (Export).",
    "composition": [
      "Each Vial Contains:",
      "Artesunate 120 mg",
      "(Sterile Lyophilized Powder)"
    ]
  },
  {
    "id": "p0515",
    "name": "Artesunate 180mg For Injection",
    "generic": "Artesunate 180mg For Injection",
    "strength": "180MG FOR INJECTION",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Export pack",
    "desc": "Artesunate 180mg For Injection (Export).",
    "composition": [
      "Each combipack contains:",
      "Artesunate Injection 180mg",
      "Composition:",
      "Each Vial contains:",
      "Artesunate (Sterile) - . 180mg",
      "Sterile sodium Chloride Injection BP ampoule",
      "Each ampoule contains:",
      "sodium Chloride BP - . 0.9% w/v",
      "Water for Injection BP - . q. s",
      "Sodium Bicarbonate Injection BP",
      "ampoule",
      "Each ampoule contains:",
      "Sodium Bicarbonate BP - . 5% w/v",
      "Water for Injection BP - . q. s"
    ]
  },
  {
    "id": "p0516",
    "name": "Teicoplanin Injection IP",
    "generic": "Teicoplanin Injection IP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "Domestic pack",
    "desc": "Teicoplanin Injection IP (Domestic).",
    "composition": [
      "Each vial contains:",
      "Teicoplanin IP - 400mg"
    ]
  },
  {
    "id": "p0517",
    "name": "Hydrocortisone Sodium Succinate Injection BP",
    "generic": "Hydrocortisone Sodium Succinate Injection BP",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "Export pack",
    "desc": "Hydrocortisone Sodium Succinate Injection BP (Export).",
    "composition": [
      "Each vial Contains:",
      "Sterile Hydrocortisone Sodium Succinate USP",
      "Eq. to Hydrocortisone - 100mg"
    ]
  },
  {
    "id": "p0518",
    "name": "Glutathione For Injection 600mg",
    "generic": "Glutathione For Injection 600mg",
    "strength": "600MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Export pack",
    "desc": "Glutathione For Injection 600mg (Export).",
    "composition": [
      "Each vial contains:",
      "Glutathione USP - 600mg"
    ]
  },
  {
    "id": "p0519",
    "name": "Ascorbic Acid Injection I.p.",
    "generic": "Ascorbic Acid Injection I.p.",
    "strength": "As specified",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "Domestic pack",
    "desc": "Ascorbic Acid Injection I.p. (Domestic).",
    "composition": [
      "Each 2ml contains:",
      "Vitamin C IP - 500mg",
      "Water for Injection IP - q.s."
    ]
  },
  {
    "id": "p0520",
    "name": "Latanoprost Ophthalmic Solution 0.005% W/v",
    "generic": "Latanoprost Ophthalmic Solution 0.005% W/v",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "Domestic pack",
    "desc": "Latanoprost Ophthalmic Solution 0.005% W/v (Domestic).",
    "composition": [
      "Each ml contains:",
      "Latanoprost - 0.005% w/v",
      "Benzalkonium Chloride Solution IP - 0.02% w/v",
      "(As Preservative)",
      "Sterile aqueous vehicle - . - q.s."
    ]
  }
];
